/**
 * 일지 메인 — 오더 상세보기/작업흐름(현장도착·배차취소·작업완료·수금완료)/결제·가격변경/
 * 메모·지출/사진/오더복사·예약전환/통화·네비 (구 public/js/m-diary.js 이관, 함수 165개).
 *
 * [점진 이관] babel AST 코드모드로 변환 — 암묵전역 35개(handle_orderNum/confirm_ok_act/
 * CancelType/eaoinfo_order_address/last_payType …)를 식별자 노드만 정확히 window.* 화(문자열/객체키
 * 불변). 함수는 모듈스코프 선언 그대로 두고 생성자에서 window 일괄등록 → 내부/크로스(Calendar·
 * PaymentModal·TaxBill·PHP onclick·iframe parent.*) bare 호출이 전부 window 로 해소. (diary-js-migration.md §3)
 *
 * [iframe] 상세버튼 onclick 은 parent(부모) 윈도우 실행 — parent.showDetailTableFrameResult/
 * loadOrderPhotos/ORDER 가 부모 전역으로 노출돼야 함(아래 등록에 포함).
 * [공유전역] billsetDiv(TaxBill), m5_chaddrNo(PHP 인라인) 는 window.* 로 접근.
 */
import Util from '../../../Common/Util';
import Store from '../../../Common/Store';
export default class Main {
    constructor() {
        if (typeof window.billsetDiv === 'undefined') window.billsetDiv = null;
        if (typeof window.m5_chaddrNo === 'undefined') window.m5_chaddrNo = 0;
        Object.assign(window, {
            memoPopShow, memoPopHide, memoPopClear, baljooToSelf, callback_worktime_ok, check_speech_On_Off,
            work_done_SignStart, sendMoVer, SpeechListen, Change_reserv_to_app, Change_reserv_to_appDo, showDetailTableFrameResult, set_userDocShare,
            getUrlVars, showDetailTable, showDetail, show_n_ch, opacitySetBlur, reset_borderS, prepare_first,
            page_init, changeDIrectToOther, closeDetail, clearBoxs, imusetPee, order_info_change_pre, zipserchWinJob, check_filecontract,
            onClickFieldNumberDiv, fieldInfoChange, change_fieldInfo, copyOrder, openContractPop, driver_changePopShow, check_memo,
            check_expense, load_expenses_list, check_extypeset, carDriverSet_Driver, carDriverSet_Car, obj_stylechangte, page_chnage, page_unchange,
            carDriverSetdone, confirm_cancelorder_select_05, set_selectedNumAgain, order_Cancel_Do, order_cancel_edit_order,
            make_getinfos, put_value_infos, reservOrderCancel, send_field_arrival_noty, ready_send_arrival, work_done_infos_confirm_Btn_OK, addPhotoPrepare, cash_view,
            pushReq_redirect, send_field_arrival_request, ask_cancelorder_check, ask_cancelorder, ask_cancelorder_run, panalty_cancelorder, panalty_cancelorder_run, selectOrderToCancel_ask, send_job_done_request, reqest_paymentdone,
            input_by_contact, addphotoHere, updateWorksPhoto, add_expances, add_workMemos, TR_row_hide, reg_inofs_tolist, soojooPeeChangeDo, opt_selectPosshowx, payment_ChangeDo, car_price_Change, _openPhoneModal,
            _openPriceModal, _openWorkDayTimeModal, change_dataThing, naviCallTo, mapRunDo, showRoadView, record_call_log, show_carNumDetail,
            checkDateserch, addmemo, memo_set_to, deleteMemoea, callbackAddress, showthisPhoto, loadOrderPhotos, renderOrderPhotos,
            deleteone, popcloseimg, shareFile, downloadit, get_eaOrder_expancess, resetSearchs, getDocHeight, work_DocJob,
            get_bonsa_col, changeBonsaCol, getMcInsPop, get_car_parking_pee, change_parking_pee, sendNotoTo_ownerorderget, sendNotoTo_Baljoo_checked, app_priceReservEr,
            showMap, setTo_noPee, AserverNot, changePlateNum, saveCarPlateFront, FilterSelectSetdo, FilterSelect,
            address_result_Show, address_result_ShowDB, getNum, diary_RegnewTypeSelBtns, loadScript,
            setBillStats, setBillStatsDo, reg_TaxmoreScript, showDoc, sendMydocTo, sendDocShareLevel, docShareAccept, docShareReject,
            sendRequestTo, imageShowList, modalMap, requestRemoteSafetySign,
        });
    }
}

/** memoinputmore 팝업 표시/숨김 */
function memoPopShow() {
    $('#memoinputmoreTop, #memoinputmore').show();
}

function memoPopHide() {
    // BS 로 띄운 경우와 레거시 팝업 둘 다 닫는다 — 안쪽 '닫기' 버튼들이 이 함수만 부른다
    if ($('.bottomsheet-popup').hasClass('is-open')) $j.Ui.BS.close();
    $('#memoinputmoreTop, #memoinputmore').hide();
}
function memoPopClear() {
    $('#memoinputmore').empty();
    memoPopHide();
}

/**
 * 임의발주
 */
function baljooToSelf(){
    var adr = `/m/ajax/order/${ORDER['num']}/car`;
    var sendData = {
        "diiverNum": ORDER.$r['worker_num'],
        "carNum": ORDER.$r['car_num'],
    };
    $.ajax({type:"POST", url:adr , data:sendData , dataType:'json',success:function(data){
        if( data.status == true){
            document.location.href="?showipicknum=" + ORDER['num'];
        }else{
            alert(data.error);
        }
    }});
}



/**
 * 작업시간 수정후 콜백함수
 */
function callback_worktime_ok(work_time){

}


// function initDaum(){
//     ps = new daum.maps.services.Places();
//     geocoder = new daum.maps.services.Geocoder();
// }
function check_speech_On_Off(){
    if( window.orderReadSet != -1) return;
    var ch = parseInt(Store.cookie.get("orderReadSetvalue"));
    if( isNaN(ch)) ch = 1;
    window.orderReadSet = ch;
    var obj = document.getElementById("regorderExpspeaker");
    if( ! obj) { console.log(" 사운드 읽어줄 아이콘 대상없음"); return;}
    window.orderReadSet == 1 ? obj.src="/img/icon_speakertop_on.png" : obj.src="/img/icon_speakertop_off.png";

}

// function sendMbno(){
//     return LoginNo;
// }
//
// function push_message_Update_line(){
// }
// (진행바 로직은 Pages/Mobile/Diary/ProgressBar.js 로 이관 — reset_processArray/re_Make_process_Array/
//  check_Process_fallow/do_order_follow/show_results 는 그 모듈이 window 로 등록한다.)

/**
 * 작업완료 버튼
 * @param orderNum
 * @param howtopay_num
 * @param TableNum
 * @param worker_carnumInt
 * @param tar
 */
function work_done_SignStart(orderNum){
    // 보험 정산 오더(화물공제조합·KB손해보험) + 수주자 → 필수사진 체크
    const _sosok = ORDER ? (ORDER['order_sosok'] || '') : '';
    const isMercury = _sosok.indexOf('022002') === 0 || _sosok.indexOf('022003') === 0;
    const isSooju = MEMBER && MEMBER['mem_ownercode'] !== ORDER['order_owner_num'];

    if (isMercury && isSooju) {
        $.get(`/m/ajax/order/${orderNum}/photo-check`, function (r) {
            if (!r.result) { Util.swalert('필수사진 확인 중 오류가 발생했습니다.'); return; }

            // 누락 항목을 성격별로 분리: 사진(이 화면에서 촬영) vs 서류(서류등록 페이지에서 등록)
            const photoMissing = [];
            if (!r.photo_before) photoMissing.push('작업전 사진');
            if (!r.photo_after)  photoMissing.push('작업후 사진');
            const docMissing = [];
            if (!r.bank)      docMissing.push('통장사본');
            if (!r.business)  docMissing.push('사업자등록증');

            if (photoMissing.length || docMissing.length) {
                showWorkDoneGuide(orderNum, photoMissing, docMissing);
                return;
            }

            location.href = '/m/diary/done?ordernum=' + orderNum;
        });
        return;
    }

    location.href = '/m/diary/done?ordernum=' + orderNum;
}

/**
 * 작업완료 준비 안내 모달 ($j.Ui.Modal center).
 * 누락 항목을 사진(이 화면에서 촬영) / 서류(서류등록 페이지) 로 나눠 안내하고,
 * 각 섹션에 바로 등록하러 가는 버튼을 제공한다.
 *   - 현장 사진 → 사진 등록 바텀시트(DiaryPhotoHub, 사진 탭) 열기
 *   - 필수 서류 → 서류등록 페이지 이동 (소유자만; 소속자는 요청 안내)
 * @param orderNum     현재 오더번호
 * @param photoMissing string[] 누락된 현장사진 라벨
 * @param docMissing   string[] 누락된 필수서류 라벨
 */
function showWorkDoneGuide(orderNum, photoMissing, docMissing){
    // 서류(통장사본·사업자등록증)는 소유자 계정에서만 등록 가능 (DocsController 하드 차단 기준)
    const isOwner = !!(MEMBER && MEMBER['mem_permit'] === '소유자');
    const li = (arr) => arr.map((x) => '<li>' + x + '</li>').join('');

    let body = '<div class="wdg-wrap">'
        + '<p class="wdg-lead">작업완료 전 아래 항목을 준비해 주세요.</p>';

    if (photoMissing.length) {
        body += '<div class="wdg-sec">'
            + '<div class="wdg-sec-head"><span class="wdg-ico">📷</span>현장 사진</div>'
            + '<ul class="wdg-list">' + li(photoMissing) + '</ul>'
            + '<p class="wdg-hint">작업 전·후 사진을 촬영해 주세요.</p>'
            + '<button type="button" class="wdg-btn wdg-btn-primary" data-act="go-photo">사진 등록하기</button>'
            + '</div>';
    }
    if (docMissing.length) {
        body += '<div class="wdg-sec">'
            + '<div class="wdg-sec-head"><span class="wdg-ico">📄</span>필수 서류</div>'
            + '<ul class="wdg-list">' + li(docMissing) + '</ul>';
        if (isOwner) {
            body += '<p class="wdg-hint">서류등록 페이지에서 <b>한 번만</b> 등록하면 다음부터 자동으로 첨부돼요.</p>'
                + '<button type="button" class="wdg-btn wdg-btn-primary" data-act="go-docs">서류 등록하기</button>';
        } else {
            body += '<p class="wdg-hint">이 서류는 <b>소유자(사장님) 계정</b>에서만 등록할 수 있어요. 소유자에게 등록을 요청해 주세요.</p>';
        }
        body += '</div>';
    }

    body += '<div class="wdg-btns"><button type="button" class="wdg-btn wdg-btn-ghost" data-act="close">닫기</button></div>'
        + '</div>';

    $j.Ui.Modal.open({
        title: '작업완료 준비',
        html: body,
        mode: 'center',
        width: '340px',
        onOpen: (h) => {
            // 현장 사진 → 사진 등록 바텀시트(사진 탭만) 열기. 모달은 닫는다.
            h.el.find('[data-act="go-photo"]').on('click', () => {
                h.close();
                // 상단 탭(작업문서 | 현장사진)은 모두 노출하되 현장사진 탭으로 열기
                $j.Ui.BS.open({
                    target: '$j.F.Diary.DiaryPhotoHub',
                    fixedHeight: true,
                    data: { ordernum: orderNum, tab: 'photo', visibleTabs: ['doc', 'photo'] },
                });
            });
            // 필수 서류 → 서류등록 페이지 이동
            h.el.find('[data-act="go-docs"]').on('click', () => { h.close(); location.href = '/m/docs/v1'; });
            h.el.find('[data-act="close"]').on('click', h.close);
        },
    });
}
function sendMoVer(ver){
    var NowVer = 10.20;
    var ver = parseFloat(ver);
    if( ver > 1 ){
        window.mobie_ver = ver;
        if( ver > 10 ){
            if( ver < NowVer ){
                var mg = "장비불러 앱이 업데이트 되었습니다.\n앱을 업데이트 하시겠습니까?";
                var adr = "/apk_nitice_download.php?myver=" + ver;
                if( confirm(mg)){
                    window.open(adr);
                }
            }
        }

    }
}
function SpeechListen(howinput, act,ttsword){
    var mbnox = user_loginNum;
    $j.F.App.listenStartVoice(howinput, act , ttsword,1);
}
// 구 get_speechWord() shim 은 2026-08 제거 — STT 결과는 callbackBroker → callbackSpeechResult →
// EventBus 'app:speech:result' 단일 경로로 온다 (UI 로직은 page_init 의 구독자).

/**
 * 예약오더 -> 어플발주 컨펌 다이얼로그 띄우기
 * @param orderno
 * @constructor
 */
function Change_reserv_to_app(orderno){
    // 결제책임 체크
    if($('#soojooPeeChange').html()=='정의된값없음'){
        $('#soojooPeeChange').click();
        return;
    }

    var hh = "<div style='width:100%;display:block;text-align:center;font-size:17px;font-weight:bold; margin-bottom:50px' id='memoboxIn'>";
    hh +=	 "<div style='width:100%;height:40px;line-height:40px;font-size:20px;font-weight:bolder;text-align:center; padding-top:30px; border-bottom:2px solid var(--diary-border)'>예약오더 -> 어플발주하기</div>";
    hh +=	 "<div style='width:90%;margin:0px auto; line-height:18px;font-size:17px;font-weight:normal;text-align:left; padding-top:30px; margin-bottom:20px; text-align:left ;line-height:30px'>";
    hh += "이 오더를<br>장비불러 회원이 수주할 수 있게<br>어플 발주 할까요?";
    hh += "</div>";

    hh +=    "<input type='button' value='취소' style='width:80px;height:50px;font-size:15px; color:var(--diary-accent); background-color:var(--diary-surface); border:1px solid var(--diary-accent);-webkit-border-radius:5px;border-radius:5px; ' onclick=\"memoPopHide()\"' id='savememobtn1'>&nbsp;&nbsp;";
    hh +=    "<input type='button' value='발주' style='width:120px;height:50px;font-size:17px;background-color:var(--diary-accent);border:none; color:var(--diary-ink-fixed);-webkit-border-radius:5px;border-radius:5px;font-weight:bolder  ' id='changefdinfo' onclick='Change_reserv_to_appDo(" + orderno + ")'>";
    hh += "</div>";
    $('#memoinputmore').html(hh).css('top', '10px');
    memoPopShow();
}

/**
 * 예약오더 -> 어플발주
 * @param orderno
 * @constructor
 */
function Change_reserv_to_appDo(orderno){
    $.ajax({
        type: "POST",
        url: `/m/ajax/order/${orderno}/reserve2app`,
        dataType: 'JSON',
        success: (data) => {
            if( !data.result){
                Util.swalert(data.message);
                return;
            }
            location.href='/m/diary?showipicknum='+orderno;
        },
        complete: () => {
        }
    });
}

function showDetailTableFrameResult(data){ ///////////////작업 내용 보기
    var tars = document.getElementById(lastSelOrderEahd);
    var LoadingTab = document.getElementById("eaLoadingArea_" + lastSelOrderEano );
    if( data == undefined) data = "";
    opacitySetBlur(window.handle_orderNum,"hide");
    if( data.indexOf("NotMyorder") >= 0 ){
        // hdd 는 이 함수의 인자/스코프에 없는 전역참조였다 (showDetailTable 에서만 쓰던 매개변수).
        // NotMyorder 응답마다 ReferenceError 로 여기서 죽어, 아래 스피너 제거(LoadingTab.innerHTML="")까지
        // 못 가서 "취소된 오더를 열면 계속 로딩"으로 보이던 원인이었다.
        var emhdd = "eaorderstty" + window.lastOpen_Tab_tab + "_" + window.handle_orderNum;
        var emter = document.getElementById(emhdd);
        if( emter ){
            emter.innerHTML = "배차취소"
        }
        var tr = document.createElement('tr');
        tr.setAttribute("isadded", "added");
        tr.innerHTML = "<td colspan=3 style='font-size:15px; font-weight:normal; padding-top:50px; padding-bottom:30px;  text-align:center; height:90px'>발주자가 취소한 오더</font></td>";
        tars.appendChild(tr);
        LoadingTab.innerHTML = "";
        document.getElementById("TdivClose" + lastSelOrderEano).style.display="block";
        return;
    }
    document.getElementById("tempShowBox").innerHTML = data;
    var div =document.getElementById("localsubTable");
    if( ! tars){
        // tars(오더 행을 붙일 대상)가 없으면 에러행도 못 붙이지만, 스피너는 지워야 무한로딩으로 안 보인다.
        if( LoadingTab ) LoadingTab.innerHTML = "";
        return;
    }
    if( ! div){
        // 상세조회 실패(권한없음/삭제됨/서버오류)로 정상 응답 HTML이 안 왔을 때.
        // 여기서 그냥 return 하면 스피너(LoadingTab)를 못 지워 화면이 계속 로딩중으로 보인다.
        LoadingTab.innerHTML = "";
        var tr = document.createElement('tr');
        tr.setAttribute("isadded", "added");
        tr.innerHTML = "<td colspan=3 style='font-size:15px; font-weight:normal; padding-top:50px; padding-bottom:30px;  text-align:center; height:90px'>작업 내용을 불러오지 못했습니다</td>";
        tars.appendChild(tr);
        document.getElementById("TdivClose" + lastSelOrderEano).style.display="block";
        return;
    }
    for ( var i =0 ; i < div.rows.length ;i++ ){
        var lines = div.rows[i];
        if( lines.getAttribute("isadded") != "addedx"){
            var tr = document.createElement('tr');
            tr.setAttribute("isadded", "added");
            //tr.setAttribute("style", "line-height:25px");
            tr.innerHTML = lines.innerHTML;
            tars.appendChild(tr);
        }
    }
    document.getElementById("TdivClose" + lastSelOrderEano).style.display="block";
    LoadingTab.innerHTML = "";
    if( lastSelOrderActt == "map" && lastTry_gps1 > 0 && lastTry_gps2 > 0 ){
        showMap(lastSelOrderEano,lastTry_gps1,lastTry_gps2,lastTry_addr,"","");
    }
    if( lastSelOrderActtsub == "keepPopupTop1"){
        add_workMemos(window.lastOpen_Tab_order);
    }
    var ggbx = 100;
    if( autoOnceDone ==9 && autoSelDate.length ==10 ){
        page_ScrollSetMt(LoadingTab);
        ggbx = 150;
    }
    console.log("lastSelOrderEano:" + lastSelOrderEano + " / onceLoad :" + window.onceLoad );

    var obj = document.getElementById("ordersetInfos_docsetst_" + lastSelOrderEano);
    if(obj){
        set_userDocShare(lastSelOrderEano);
    }

    if( window.onceLoad != 0 ) return;
    var offsets = tars.getBoundingClientRect();
    if(offsets){
        var n = offsets.top;
        if( n > 0 ){
            n = parseInt(n-ggbx);
            window.onceLoad = 1;
            setTimeout(function(){ $(window).scrollTop(n); },500);
        }
    }


    //////////////////////////////////////////////////////////////////////////////
}
var autoOpenShareDocnum = 0;

/**
 * 서류 공유요청에 대한 처리
 * 서류공유요청 알림이 들어오면 알림페이지에 버튼을 누르고 일지페이지로 들어와서 팝업이 바로 뜨도록 한다.
 * @param num
 */
// 서류공유 요청버튼 렌더 (디스크립터 → HTML). 구 _sky_m_05_ajax_share_doc_listget.php getRequestBtn 대체.
function buildReqBtn(d){
    if(!d) return "";
    var onclick = (d.actArg != null)
        ? d.action + "(this,'" + d.actType + "'," + d.actArg + ")"
        : d.action + "(this,'" + d.actType + "')";
    // 글자색 고정: 배경(d.bg)이 파스텔(연두 #B5FFC8 / 연노랑 #FEF1B6)로 테마와 무관하게 밝다.
    // 색을 안 주면 다크에서 body 의 흰 글자를 상속해 파스텔 위 흰 글씨가 되어 안 읽힌다.
    return "<div style='width:100px; height:90%; background-color:" + d.bg + ";color:var(--diary-ink-fixed);line-height:17px; display:inline-block; vertical-align:top; text-align:center; padding:10px 0px; border:1px solid var(--diary-border);-webkit-border-radius: 5px;  -moz-border-radius: 5px;  border-radius: 5px; margin-right:5px; margin-top:3px;cursor:pointer' ordernum='" + d.ordernum + "' mymemno='" + d.mymemno + "' othernumno='" + d.othernum + "' soo_cntdef='" + d.cntDef + "' soo_cntcar='" + d.cntCar + "' soo_cntman='" + d.cntMan + "' id='" + d.id + "' notilist_autoCall='" + d.notilist_autoCall + "' notilist_autosetNum='" + d.notilist_autosetNum + "' rejected='" + (d.rejected ? 1 : 0) + "' onclick=\"" + onclick + "\">" + d.label + "</div>";
}

/**
 * 오더를 펴면 **그 오더에 받은 서류공유 요청을 팝업으로 물어본다.**
 *
 * 일지 진입 때 날짜를 가리지 않고 묻던 방식은, 무슨 오더인지 모르는 채 답을 강요했다.
 * 지금은 요청 알림이 그 오더를 펴 주므로(showipicknum), 오더 화면에서 묻는다.
 *
 * '나중에'를 두는 이유: 현장에서 다른 일을 하러 들어온 사람을 가두지 않기 위해서다.
 * 닫아도 서류 영역의 카드(.shareask)에서 답할 수 있고, 같은 요청은 이 화면에서 다시 묻지 않는다.
 */
var docShareAsked = {};
function askDocShareForOrder(j){
    var p = j && j.pending;
    if( !p || docShareAsked[p.num] ) return;
    docShareAsked[p.num] = 1;
    var who  = p.role == 1 ? "발주자" : "수주자";
    var what = docRangeName(p.level);

    $j.Ui.Dialog.open({
        tone:  'info',
        title: '서류 공유 요청',
        rows: [
            { k: '요청한 쪽', v: who },
            { k: '요청 범위', v: what },
        ],
        choices: [
            { label:'공개하기', tag:what, tone:'good',
              onPick: () => docShareAccept(p.num, j.ordernum, p.level, true) },
            { label:'거절',     tag:'공개하지 않음', tone:'bad',
              onPick: () => docShareReject(p.num, true) },
        ],
        cancel: '나중에',
    });
}

/**
 * 받은 서류공유 요청 카드 (대기 중인 것 한 건).
 *
 * 구 화면엔 이게 없었다 — 요청은 푸시 한 통뿐이라 **답할 자리가 아예 없었고**,
 * 알림을 지우면 요청도 함께 사라졌다. 요청한 쪽은 거절당한 것인지 잊힌 것인지 알 수 없었다.
 * 이제 원장(g5_document_share_requests)에 남으므로, 답하기 전까지 이 카드가 서 있는다.
 */
function renderShareAsk(j){
    var p = j.pending;
    if( !p ) return "";
    var who = p.role == 1 ? "발주자" : "수주자";
    var what = p.level == 1 ? "기본서류" : (p.level == 2 ? "기본 + 장비서류" : "기본 + 장비 + 기사서류");
    return "<div class=\"shareask\">"
        + "<div class=\"shareask__msg\"><b>" + who + "</b>가 <b>" + what + "</b>를 요청했습니다.</div>"
        + "<div class=\"shareask__btns\">"
        +   "<button type=\"button\" class=\"shareask__btn\" onclick=\"docShareReject(" + p.num + ")\">거절</button>"
        +   "<button type=\"button\" class=\"shareask__btn shareask__btn--ok\" onclick=\"docShareAccept(" + p.num + "," + j.ordernum + "," + p.level + ")\">공개하기</button>"
        + "</div></div>";
}

/**
 * 수락 — 요청받은 범위 그대로 공개한다.
 * 좁혀서 열고 싶으면 공개 시트에서 다시 고르면 되므로 여기서 또 묻지 않는다.
 */
function docShareAccept(reqnum, ordernum, level, asked){
    var run = function(){
        $.ajax({type:"POST", url:"/m/ajax/doc-share/accept", data:{reqnum:reqnum, level:level}, success:function(data){
            if( data && data.result === false ){ Util.swalert(data.error || "공개할 수 없습니다.",'error'); return; }
            $j.Ui.Toast.show("서류를 공개했습니다.", { type:'success' });
            set_userDocShare(ordernum);
        }});
    };
    // 팝업에서 이미 고른 것이라면 한 번 더 묻지 않는다
    if( asked ) return run();
    Util.swalert(["요청받은 서류를 공개할까요?",'question'], run, ['네','아니오']);
}

/** 거절 — 공개하지 않고 요청자에게 알린다. 사유는 받지 않는다. */
function docShareReject(reqnum, asked){
    var run = function(){
        $.ajax({type:"POST", url:"/m/ajax/doc-share/reject", data:{reqnum:reqnum}, success:function(data){
            if( data && data.result === false ){ Util.swalert(data.error || "거절할 수 없습니다.",'error'); return; }
            $j.Ui.Toast.show("요청을 거절했습니다.", { type:'success' });
            set_userDocShare(lastSelOrderEano);
        }});
    };
    if( asked ) return run();
    Util.swalert(["서류 공유를 거절할까요?",'question'], run, ['네','아니오']);
}

// 서류 범위 이름 (1~3 누적)
function docRangeName(lv){
    return lv == 1 ? "기본서류" : (lv == 2 ? "기본 + 장비서류" : "기본 + 장비 + 기사서류");
}

// 내가 보낸 요청의 상태 — 요청 버튼 자리에 대신 선다 (서버가 버튼을 내렸다).
//
// 대기 중이면 '답변 대기', 답을 받았으면 그 결과를 남긴다. 결과를 안 남기면 **거절이 증발한다** —
// 수락은 서류가 나타나 알 수 있지만, 거절은 아무 일도 일어나지 않아 안 본 것과 구분되지 않는다.
function sentMark(j, side){
    // 요청은 한쪽 서류를 향한다 — 그 영역에서만 그린다.
    // (안 거르면 발주자·수주자 탭 양쪽에 '거절됨'이 똑같이 떠서 누가 거절했는지 알 수 없다)
    if( !j.mySent || j.mySent.side != side ) return "";
    return "<div class=\"docsent\"><b>요청함</b><span>" + docRangeName(j.mySent.level) + "</span><em>답변 대기</em></div>";
}

/**
 * 거절당한 적이 있으면 한 번 물어본다.
 *
 * 화면에 '거절됨'을 세워 두는 방법도 있었지만, 답이 끝난 일을 계속 붙들고 있어 자리만 먹는다.
 * 다시 요청할 때 알려 주는 것으로 충분하다 — 모르고 또 조르는 것과 알고 다시 묻는 것은 다르다.
 */
function askIfRejected(tar, run){
    if( Util.int(tar.getAttribute("rejected")) !== 1 ) return run();
    Util.swalert(["상대가 이전 요청을 거절했습니다. 다시 요청할까요?", 'question'], run, ['요청', '취소']);
}

// 일지 서류공유 영역 렌더 (JSON → HTML). 구 _sky_m_05_ajax_share_doc_listget.php 의 HTML 출력 대체.
function renderShareDocs(num, j){
    var CSD1 = "width:15%;display:inline-block;line-height:15px;text-align:center; margin-top:5px;vertical-align:top";
    var CSD2 = "width:95%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px";
    var CCDV = "width:100%; height:80px;border:1px solid var(--diary-border); text-align:left; white-space:nowrap;overflow-x:auto;padding-left:10px;display:";
    var soosId = "soos_docs_" + num;
    var balsId = "bals_docs_" + num;
    function docDiv(cid, v, title){
        return "<div style='" + CSD1 + "' onclick=\"imageShowList('" + cid + "','" + v.file_id + "')\">"
            + "<img src=\"" + v.file + "\" style=\"height:50px\" class=\"docimgs\" id=\"docImg_" + v.file_id + "\">"
            + "<div style=\"" + CSD2 + "\">" + title + "</div></div>";
    }

    var h = "";
    // 기한이 지나 막힌 오더 — 빈 영역만 주면 회원은 '사라졌다'가 아니라 '고장났다'로 읽는다
    if( j.expired ){
        var why = j.expiredWhy == 'canceled'
            ? "취소된 오더라 서류를 볼 수 없습니다."
            : "이 오더의 서류 공개 기간이 지났습니다.";
        return "<div class=\"docgone\">" + why + "</div>";
    }
    h += renderShareAsk(j);
    h += "<div style=\"width:100%; height:5px;clear:both\"></div>";
    h += "<div style=\"width:100%;margin:0px auto; padding:0px; white-space:nowrap;color:#FFFFFF;font-size:13px ;font-weight:normal;line-height:25px\">";
    h += "<div style=\"display:inline-block; width:50%; text-align:center;background-color:" + j.a1bg + ";color:" + j.a1cc + " ; border:1px solid var(--diary-doc-tab-border)\" id=\"doccalbtna_" + num + "\" onclick=\"showDoc(event," + num + ",1)\">발주자 문서</div>";
    h += "<div style=\"display:inline-block; width:50%; text-align:center;background-color:" + j.a2bg + ";color:" + j.a2cc + "; border:1px solid var(--diary-doc-tab-border);\" id=\"doccalbtnb_" + num + "\" onclick=\"showDoc(event," + num + ",2)\">수주자 문서</div>";
    h += "</div>";
    h += "<div style=\"width:100%; height:5px;clear:both\"></div>";

    // 수주자 문서 (발주자에게 보임)
    h += "<div class=\"docholderdiv\" style=\"" + CCDV + j.soojoo + "\" id=\"" + soosId + "\" notilist_autoCall=\"" + j.notilist_autoCall + "\" notilist_autosetNum=\"" + j.notilist_autosetNum + "\">";
    h += sentMark(j, 'soo');
    h += buildReqBtn(j.reqSoo);
    for(var i=0;i<j.sooDocs.length;i++) h += docDiv(soosId, j.sooDocs[i], j.sooDocs[i].showtitle);
    if(j.safetySign) h += docDiv(soosId, j.safetySign, "안전실천서약서");
    h += "</div>";

    // 발주자 문서 (수주자에게 보임)
    h += "<div class=\"docholderdiv\" style=\"" + CCDV + j.baljoo + "\" id=\"" + balsId + "\" bal=\"" + j.baljoo + "\" soo=\"" + j.soojoo + "\">";
    h += sentMark(j, 'bal');
    h += buildReqBtn(j.reqBal);
    for(var k=0;k<j.balDocs.length;k++) h += docDiv(balsId, j.balDocs[k], j.balDocs[k].showtitle);
    h += "</div>";

    return h;
}

function set_userDocShare(num){
    var adrParam = getUrlVars();
    var notilist_autoCall = ""; var notilist_autosetNum = "0";

    if( typeof(adrParam) == "object"){
        if( adrParam.jobtype && adrParam.reqsetval && adrParam.showipicknum==num ){
            notilist_autoCall = adrParam.jobtype;
            notilist_autosetNum = adrParam.reqsetval;
        }
    }

    var obj = document.getElementById("usedocInfoDiv_" + num);
    if( !obj ) return;

    var adr = "/m/ajax/doc-share/docs?ordernum=" + num + "&notilist_autoCall=" + notilist_autoCall + "&notilist_autosetNum=" + notilist_autosetNum;
    $.ajax({type:"get", url:adr, dataType:"json", success:function(j){
            if( !j || j.error ){ console.log("share-docs error:", j && j.error); return; }
            // #m_sky_Top(콘텐츠 컬럼) 폭의 95%. 레이아웃에 따라 없을 수 있어(empty.blade=user_target) 뷰포트로 폴백.
            // ⚠ getBoundingClientRect()/documentElement.clientWidth 는 '렌더 px', style.width 는 '레이아웃 px'.
            //   큰글씨는 body 에 zoom 을 걸므로(base/_fontsize.scss) 두 좌표계가 zoom 배만큼 어긋난다.
            //   렌더값을 그대로 style.width 에 넣으면 컬럼보다 zoom 배 넓어져 표 우측이 잘린다.
            //   → 레이아웃 px 인 offsetWidth 를 쓰고, 폴백은 --fs-zoom 으로 나눠 맞춘다.
            var tar = document.getElementById("m_sky_Top");
            var ww;
            if( tar && tar.offsetWidth ){
                ww = tar.offsetWidth;
            } else {
                var fz = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--fs-zoom")) || 1;
                ww = document.documentElement.clientWidth / fz;
            }
            // 문서 띠(가로 스크롤)를 위해 95% 로 좁히는 값이다. 만료 안내에는 띠가 없으므로
            // 그대로 두면 **오른쪽에만** 5% 여백이 남아 좌우가 안 맞는다.
            obj.style.width = j.expired ? "100%" : (parseInt(ww * 0.95) + "px");
            obj.innerHTML = renderShareDocs(num, j);
            if( !j.expired ) askDocShareForOrder(j);
            var obj1 = document.getElementById("soos_docs_" + num);
            var obj2 = document.getElementById("bals_docs_" + num);
            if( obj1 ) obj1.style.width = parseInt(ww * 0.93) + "px";
            if( obj2 ) obj2.style.width = parseInt(ww * 0.93) + "px";
        }});
}
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

var lastSelOrderEahd = "";
var lastSelOrderEano = 0;
var lastSelOrderActt = "";
var lastSelOrderActtsub = "";

/**
 * 일지 목록에서 한개의 오더를 클릭하여 오더가 펼쳐지게
 * @param n
 * @param hdd
 * @param actt
 * @param subactt
 * @param react
 * @returns {boolean}
 */
function showDetailTable(n, hdd, actt, subactt, react) {
    react = react || "";
    subactt = subactt || "";
    actt = actt || "";
    lastSelOrderActt = actt;
    lastSelOrderActtsub = subactt;

    if (subactt === "easy") {
        alert("발주이전 입니다.\n관리자가 발주 후 내역을 보실 수 있습니다");
        return;
    }

    const $loadingTab = $(`#eaLoadingArea_${n}`);
    const eahd = `detailShowTr${hdd}_${n}`;
    lastSelOrderEahd = eahd;
    const $tars = $(`#${eahd}`);

    const $inputsx = $tars.find("tr");
    let TabIsOpen = 0;
    $inputsx.each(function () {
        if ($(this).attr("isadded") === "added") {
            TabIsOpen = 1;
            return false; // break the loop
        }
    });

    const mapDivId = G5['MAP_ID'];
    const NoAct = ["photoGallDiv", "crd", "memoinputmore", "dateChingTingTop", mapDivId];

    if (react !== "ForceToTab") {
        for (let x = 0; x < NoAct.length; x++) {
            const $objx = $(`#${NoAct[x]}`);
            if ($objx.length && $objx.css("display") === "block") {
                return;
            }
        }
    }

    if (actt && react !== "ForceToTab") {
        const ty = actt.target?.id || "";
        if (["changeDateSpan", "GPSBTNICON", "addrchangebtn"].includes(ty)) {
            actt.preventDefault();
            actt.stopPropagation();
            return false;
        }

        if (TabIsOpen === 1) {
            let gps = "", adr = "";
            if (ty.includes("a_addressinside")) {
                gps = $(actt.target).data("gps") || "";
                adr = $(actt.target).data("addr") || "";
            } else if (ty.includes("adr_keyword")) {
                const $obj = $(actt.target).parent();
                gps = $obj.data("gps") || "";
                adr = $obj.data("addr") || "";
            } else if (ty.includes("orderTapEa_")) {
                gps = $(actt.target).find("span").first().data("gps") || "";
                adr = $(actt.target).find("span").first().data("addr") || "";
            }

            if (gps.length > 10 && adr.length > 2) {
                naviCallTo(gps, adr);
                actt.preventDefault();
                actt.stopPropagation();
                return false;
            }
            return false;
        }
    }

    window.handle_orderNum = n;
    window.lastOpen_Tab_order = window.lastOpen_Tab_order || 0;
    window.lastOpen_Tab_tab = window.lastOpen_Tab_tab || "";
    window.lastOpen_Tab_act = window.lastOpen_Tab_act || "";

    if (window.lastOpen_Tab_order > 0 && window.lastOpen_Tab_tab) {
        closeDetail(window.lastOpen_Tab_order, window.lastOpen_Tab_tab);
    }

    if (subactt !== "keepPopupTop1") {
        memoPopHide();
    }

    window.lastOpen_Tab_order = n;
    window.lastOpen_Tab_tab = hdd;
    window.lastOpen_Tab_act = actt;

    lastSelOrderEano = n;
    reset_borderS();

    const $topEaTable = $(`#eatbtop_${n}`);
    if ($topEaTable.length) {
        $topEaTable.css({
            borderBottom: "3px solid var(--diary-card-edge)",
            borderTop: "0px solid var(--diary-card-edge)"
        });

        $topEaTable.find("div").each(function () {
            const dataType = $(this).data("type");
            if (["change_Date", "change_Price"].includes(dataType)) {
                $(this).show();
            } else if (dataType === "NaviBtnbox") {
                $(this).css("display", "inline-block");
            }
        });
        $topEaTable.find("span").each(function () {
            if ($(this).data("type") === "dateChangeSpan" && $(this).attr("canChangeDateTime") == "1") {
                $(this).css({
                    textDecoration: "none",
                    borderBottom: "3px solid var(--diary-accent)"
                });
            }
        });
    }

    $(".changeAddrr").hide();
    $topEaTable.find("div.changeAddrr").css("display", "inline-block");

    $(`#orderTapEa_${n}`).css("white-space", "normal");

    window.last_CallShowOrder = n;

    n = parseInt(n, 10);
    if (n === 0 || isNaN(n)) return;

    showDetail(n, hdd);
    $loadingTab.html("<br><br><br>" + $j.Common.Util.spinnerHtml('jb-spin--fade') + "<br><br><br>");

    const withApp = window.App ? "appinside" : "pcinside";

    $.getJSON(`/m/ajax/order/${n}/detail-view`, {
        showmodeapp: withApp,
    }).done(function (res) {
        if (!res || !res.ok) {
            showDetailTableFrameResult("");
            return;
        }
        if (res.notmyorder) {
            showDetailTableFrameResult("___NotMyorder");
            return;
        }

        window.ORDER = res.order;
        showDetailTableFrameResult(res.html);
        loadOrderPhotos(res.ordernum);
    }).fail(function () {
        showDetailTableFrameResult("");
    });

}

function showDetail(n,hdd){
    if( hdd==undefined){
        window.last_CallShowOrder = 0;
        show_n_ch(n);
        return;
    }
    var eahd = "detailShowTr" + hdd + "_" + n;
    var tars = document.getElementById(eahd);
    while ( tars.rows.length > 3 ){
        tars.deleteRow(tars.rows.length-1);
    }
}

function show_n_ch(n){
    var ch1 =  "detailShowTr_St1_" + n; var ok1 = "_St1";
    var ch2 =  "detailShowTr_St2_" + n; var ok2 = "_St2";
    var ch3 =  "detailShowTr_St3_" + n; var ok3 = "_St3";
    if(document.getElementById(ch1)) showDetail(n,ok1);
    if(document.getElementById(ch2)) showDetail(n,ok2);
    if(document.getElementById(ch3)) showDetail(n,ok3);
}
function opacitySetBlur(tarhd, jobact){
    var obj = document.getElementById("mginsideloading");
    var inputs = obj.getElementsByTagName("DIV");
    if( !inputs) return;
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].getAttribute("istopdiv") == "1"){
            var rsno = parseInt(inputs[i].getAttribute("rsno"));
            if( isNaN(rsno)) rsno = 0;

            if( rsno ==tarhd){
                inputs[i].style.opacity="1";
            }else{
                if(jobact == "show"){
                    inputs[i].style.opacity="0.6";
                }else{
                    inputs[i].style.opacity="0.6";
                }
            }
        }
    }
    //var obj = document.getElementById(tarhd);
    //obj.style.opacity="1";
}

function reset_borderS(){
    var obj = document.getElementById("mginsideloading");
    var inputs = obj.getElementsByTagName("div");
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].getAttribute("data-type") == "topEaTable"){
            inputs[i].style.borderBottom = "1px solid var(--diary-card-edge)";
        }//
        //btnBotClose
        if(inputs[i].getAttribute("data-type")=="change_Date" || inputs[i].getAttribute("data-type") == "change_Price"){
            //inputs[i].style.display="none";
        }
    }
}

function prepare_first(n){
    var ch1 =  "detailShowTr_St1_" + n; var ok1 = "_St1";
    var ch2 =  "detailShowTr_St2_" + n; var ok2 = "_St2";
    var ch3 =  "detailShowTr_St3_" + n; var ok3 = "_St3";
    if(document.getElementById(ch1)){ showDetailTable(n,ok1); return;}
    if(document.getElementById(ch2)){ showDetailTable(n,ok2); return;}
    if(document.getElementById(ch3)){ showDetailTable(n,ok3); return;}
}


// var keeperNetID = null;
// function sKeeDo(){
//     // document.getElementById("sessionkeep_main").src="session_keep_frame.php";
//     // document.getElementById("sessionkeep_sub").src="session_keep_frame.php";
// }
// (check_Process_fallow 는 ProgressBar.js 로 이관 — window 전역으로 등록되어 page_init 에서 그대로 호출.)
function page_init(){
    // load_CssEx();
    // if( OTPStop == 1 ) drawOtpBox();
    // (구 #infosBoxshjow 팝오버를 스크롤 시 숨기던 핸들러 제거 — show_carNumDetail 이 BS 로 전환됐다.)
    check_Process_fallow()

    // if( document.getElementById("sessionkeep_main") && document.getElementById("sessionkeep_sub") ){
    //     keeperNetID = setInterval("sKeeDo()", 60000);
    // }
    if( ! isNaN(first_orderNUMShow)){
        prepare_first(first_orderNUMShow);
    }


    // 현장사진/작업문서 바텀시트 닫힐 때 사진 목록 갱신
    $j.Common.EventBus.on(G5['NS'], 'BS:close', function(e, payload) {
        if (payload && payload.target === '$j.F.Diary.DiaryPhotoHub') {
            var ordernum = ORDER && ORDER['num'];
            if (ordernum) loadOrderPhotos(ordernum);
        }
    });

    // 현장사진/작업문서 업로드 완료
    $j.Common.EventBus.on(G5['NS'], 'upload:image', function(e, payload) {
        const ctx = $j.F.Upload.getContext() || '';
        if( ctx.indexOf('diaryPhoto:') !== 0) return;
        const tag = ctx.split(':')[1]; // diary1 or diary2
        updateWorksPhoto(payload, tag);
    });

    // STT 인식 결과 — 구 get_speechWord 의 UI 로직
    $j.Common.EventBus.on(G5['NS'], 'app:speech:result', function(e, data) {
        const howinput = data && data.howinput;
        const jobAct   = data && data.jobAct;
        let   word     = (data && data.word) || '';

        const $last = $('#voiceRead_last');
        if ($last.length) $last.val('');
        $('#googleSpeechIn').html(word);
        $('#carSpeechgetDiv').html(word);

        if (howinput !== 'directinput') return;
        const $tar = $('#' + jobAct);
        if (!$tar.length) return;

        // listMemoregistext 외 다른 필드는 이미 값이 있으면 덮어쓰지 않음
        if ($tar.val().length > 0 && jobAct !== 'listMemoregistext') return;

        // "없음/없어/없다" 는 공란으로 처리
        if (word === '없음' || word === '없어' || word === '없다') word = '';

        if (jobAct === 'listMemoregistext') {
            let mg = ($tar.val() || '').trim();
            if (mg.length > 1) mg += ' ';
            $tar.val(mg + word);
        } else {
            $tar.val(word);
        }
    });
}

/**
 * 일지에서 수주자 변경
 * @param orderNo
 */
function changeDIrectToOther(orderNo){
    _openPhoneModal({
        from: '일지',
        why: '수주자',
        ordernum: orderNo,
        is_fee: ORDER['is_fee'],
        isRecentDisable: MEMBER['mem_driver_type']!='수발주자',
        isFeeEditDisable: !Util.isSosokJbbuller(ORDER['order_sosok']),
    }, ($r) => {
        switch (Util.int($r['order_type'])) {
            case 91: // 소속자
                baljooToSelf();
                break;
            case 95: // 타회원
                if (ORDER['order_type']==91 && ORDER['order_status']==8) {
                    ORDER.$r['worker_num']=0; // 비회원으로 처리
                }
                $j.F.Order.Biz.baljooToOther(ORDER);
                break;
            case 94: // 비회원
                $j.F.Order.Biz.baljooToOther(ORDER);
                break;
        }
    });
}

function closeDetail(n,hdd){
    var eahd = "detailShowTr" + hdd + "_" + n;
    var tars = document.getElementById(eahd);
    opacitySetBlur("","show");
    if( ! tars ) return;
    var inputs = tars.getElementsByTagName("TR");
    document.getElementById("TdivClose" + n).style.display="none";
    var dels = [];
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].getAttribute("isadded") == "added"){
            dels.push(inputs[i]);
        }
    }
    for (var i = 0 ; i < dels.length;i++ ){
        tars.removeChild(dels[i]);
    }
    var topEaTable = document.getElementById("eatbtop_" + n);
    if( topEaTable){
        topEaTable.style.borderBottom = "1px solid var(--diary-card-edge)";
        topEaTable.style.borderTop = "0px solid var(--diary-card-edge)";
        inputs = topEaTable.getElementsByTagName("div");
        for (var i=0; i < inputs.length ; i++ ){
            if(inputs[i].getAttribute("data-type")=="change_Date" || inputs[i].getAttribute("data-type") == "change_Price" || inputs[i].getAttribute("data-type") == "selectNaviApp"){
                inputs[i].style.display="none";
            }
        }
        inputs = topEaTable.getElementsByTagName("SPAN");
        for (var i=0; i < inputs.length ; i++ ){
            if(inputs[i].getAttribute("data-type")=="dateChangeSpan" ){
                inputs[i].setAttribute("style","");
            }
        }
    }
    clearBoxs(tars);
}
function clearBoxs(obj){
    var inputs = obj.getElementsByTagName("div");
    for (var i=0; i < inputs.length ; i++ ){
        if ( inputs[i].getAttribute("data-type") == "topEaTable"){
            inputs[i].style.borderBottom = "1px solid var(--diary-card-edge)";
        }//
        if(inputs[i].getAttribute("data-type")=="change_Date" || inputs[i].getAttribute("data-type") == "change_Price"){
            //inputs[i].style.display="none";
        }
    }
}

function imusetPee(n){
    var obj1 = document.getElementById("imuPeehasit1");
    var obj2 = document.getElementById("imuPeehasit2");
    document.getElementById("imutodireictpeehasit").value=n;
    if( n == 0 ){
        obj1.src="/img/checkbox_radio_yellow.svg";
        obj2.src="/img/checkbox_radio_yellow_on.svg";
    }else{
        obj1.src="/img/checkbox_radio_yellow_on.svg";
        obj2.src="/img/checkbox_radio_yellow.svg";
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 저장하는것은 이 아래로

function order_info_change_pre(no){
    window.page_handleNum = no;
}

function zipserchWinJob(){}

/**
 * 일지에서 거래처 변경
 * @param ordernum 오더번호
 * @param hpName 거래처명
 * @param hp 거래처번호
 */
function check_filecontract(ordernum,hpName,hp){
    if( hp.length < 5 ){
        //swal1("","거래처 전화번호가 없거나 잘못되었습니다.","warning");
        return;
    }
    hp = Util.phoneNumber(hp);
    var adr = `/m/ajax/order/${ordernum}/contract`;
    var sendDatas ={"cont_name":hpName ,"cont_cel":hp};
    $.ajax({
        type : 'POST',
        url : adr,
        data: sendDatas ,
        dataType: 'json',
        success : function (data){
            if( data.result ){
                var obj = document.getElementById("tdcontact_infoin");
                obj.innerHTML = hpName + "  " + hp;
                obj.setAttribute("onclick", "document.location.href='" + hp+ "'");
            }
        }
    });
}


/**
 * 현장 번호 영역 클릭시
 * @param el
 */
function onClickFieldNumberDiv(el){
    const smode = MEMBER['mem_ownercode']==ORDER['order_owner_num'];
    if( ORDER['order_type']==0 && !smode && ORDER['site_phone']>'' && parseInt(ORDER['bal_call_confirmed'], 10) !== 1 ) {
        Util.swalert('발주자통화 후 현장통화 가능.');
        return;
    }
    if( ORDER['site_phone']>''){
        document.location.href = 'tel:' + ORDER['site_phone'];
    }
}



/**
 * 현장번호 변경 팝업
 * @param no1
 * @param no2
 */
function fieldInfoChange(no1, no2){
    _openPhoneModal({
        from: '일지',
        why: '현장',
        ordernum: ORDER['num'],
        isRecentDisable: MEMBER['mem_driver_type']!='수발주자',
    }, ($r) => {
        change_fieldInfo(Util.phoneNumber($r['hp']));
    });
}


/**
 * 현장번호 변경 콜백함수
 * @param nTel 전화번호
 */
function change_fieldInfo(nTel){
    window.Tableno=ORDER['num'];
    window.orderNo=ORDER['num'];
    // var nTel = document.getElementById("fieldInfochangeIn").value;
    // if( nTel == undefined) nTel = "";
    // nTel = nTel.trim();
    var obj = document.getElementById("eaFieldInfoTDDiv_" + window.Tableno);

    memoPopHide();

    var adr = `/m/ajax/order/${ORDER['num']}/field-number`;
    var sendData = {"fnum":nTel};
    // console.log( adr );
    // console.log( sendData);
    $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
            if( !data.result ){
                alert("저장 실패 ! 관리자에게 문의하거나 다시 시도해 주세요");
            }else{
                // 값 자리는 입력칸이 아니라 텍스트다(거래처 행과 같은 규칙).
                // ORDER 도 같이 맞춰야 새로고침 없이 방금 넣은 번호로 전화가 걸린다.
                $(obj).text(nTel);
                ORDER['site_phone'] = nTel;
            }
        }});
}

/**
 * 오더복사 방법 선택
 *
 * 두 방법의 차이는 '발주자(거래처) 정보가 따라오느냐' 하나뿐이다. 그 한 줄만 뱃지로 세우고
 * 설명 문단은 없앤다 (구 jquery-modal + 인라인 style 뭉치).
 * @param onum
 */
function copyOrder(onum){
    const go = (balcopy) => { document.location.href = `/m/bal?mode=copyorder&editnum=${onum}&balcopy=${balcopy}`; };
    $j.Ui.Dialog.open({
        title:   '오더복사',
        choices: [
            { label: '오더만 복사',      tag: '시간·주소·장비', onPick: () => go(0) },
            { label: '발주자 정보까지',  tag: '+ 거래처 입력',  onPick: () => go(1) },
        ],
        cancel:  '닫기',
    });
}


/**
 * 거래처 변경 팝업
 */
function openContractPop(){
    _openPhoneModal({
        from: '일지',
        why: '거래처',
        ordernum: ORDER['num'],
        isRecentDisable: MEMBER['mem_driver_type']!='수발주자',
    }, ($r) => {
        check_filecontract(ORDER['num'], Util.nvl($r['hp_name']), $r['hp']);
    });
}
/**
 * 소속자 변경 팝업
 * @param orderNo
 */
function driver_changePopShow (orderNo){
    _openPhoneModal({
        from: '일지',
        why: '소속자',
        ordernum: orderNo,
    }, () => {
        baljooToSelf();
    });
}

/**
 * 일정등록
 */
function check_memo(){
    if( window.lastCallShowDay == undefined) window.lastCallShowDay = "";
    if( window.lastCallShowDay.length != 10 ){alert("선택한 날짜가 없습니다."); return; }
    var memoval = document.getElementById("listMemoregistext").value;
    if( memoval.length < 2 ){alert("메모 내용을 2자이상 입력해 주세요");return;}
    var regmbno = user_loginNum;
    var regowner_mbno = user_ownerNum;

    var adr = "/m/ajax/daily/memo/add";
    var sendData = {"dayval":window.lastCallShowDay, "memoval":memoval };
    $.ajax({type:"POST", url:adr , data:sendData , dataType:'json', success:function(data){
            document.getElementById("listMemoregistext").value = "";
            var cc = data.datas;
            var daymemo = cc.length;
            var obj = document.getElementById("TD_" + window.lastCallShowDay );
            var inputsP = obj.getElementsByTagName("SPAN");
            var oneP = null;
            if( inputsP.length > 0 ) oneP = inputsP[0];
            showMemosInList(cc);
            if( oneP){
                if( daymemo > 0 ){
                    oneP.style.display="inline-block";
                    oneP.innerHTML = daymemo;
                }else{
                    oneP.style.display="none";
                    oneP.innerHTML = "";
                }
            }
        }});
}



function check_expense(){
    var expensetitle = document.getElementById("expensetitle").value;
    var ex_titsub = document.getElementById("expensesub").value;
    var expenseamount = document.getElementById("expenseamount").value;
    expenseamount = expenseamount.replace(/,/gi, "");
    var expensetype = 0;
    if( document.getElementById("expensetypeA").checked==true) expensetype = 1;
    if( document.getElementById("expensetypeB").checked==true) expensetype = 2;
    var expensestart = document.getElementById("expensestart").value;
    var expenseend = document.getElementById("expenseend").value;
    if( expensetitle.length < 1 ){Util.swalert("지출항목을 입력(선택)해 주세요"); return; }
    if( expenseamount.length < 1 ){Util.swalert("금액을 입력해 주세요"); return; }
    if( expensetype == 0 ){Util.swalert("지출유형(매달, 이달만 중)을 선택해 주세요"); return; }
    if( expensestart.length < 10 ){Util.swalert("시작일을 선택해 주세요"); return; }
    if( expenseend.length < 10 ){Util.swalert("종료일을 선택해 주세요"); return; }
    var calender_yearval = document.getElementById("calender_yearval").value;
    var calender_monthval = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var editNo = parseInt(document.getElementById("expenseSaveno").value);
    if( isNaN(editNo)) editNo = 0;

    var regmbno = user_loginNum;
    var regowner_mbno = user_ownerNum;

    var adr = "/m/ajax/diary/expense/save";
    var sendData = {"expensetitle":expensetitle,  "expenseamount":expenseamount,  "expensetype":expensetype,  "expensestart":expensestart,  "expenseend":expenseend ,"tar_year":calender_yearval,  "tar_month":calender_monthval ,"tar_day":window.lastCallShowDay, "orders": selected_date_ordernumList ,"editNo":editNo, "ex_titsub":ex_titsub, "regmbno":regmbno,"regowner_mbno":regowner_mbno};
    $.ajax({type:"POST", url:adr , data:sendData , dataType:'json', success:function(data){
            var st = data.status;
            if( st == false){
                Util.swalert(data.error,"");
                return;
            }
            document.getElementById("expenseSaveno").value="0";
            document.getElementById("expenseSaveBtn").innerHTML="등 록";
            document.getElementById("expensetitle").value = "";
            document.getElementById("expenseamount").value = "";
            load_expenses_list();

        }});
}

function load_expenses_list(){
    var calender_yearval = document.getElementById("calender_yearval").value;
    var calender_monthval = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var adr = "/m/ajax/diary/expense/day";
    var regmbno = user_loginNum;
    var regowner_mbno = user_ownerNum;

    var sendData = {"tar_year":calender_yearval,  "tar_month":calender_monthval ,"tar_day":window.lastCallShowDay, "orders": selected_date_ordernumList, "regmbno":regmbno,"regowner_mbno":regowner_mbno};
    $.ajax({type:"GET", url:adr , data:sendData , dataType:'json', success:function(data){
            var DT = data.datas;
            var obj = document.getElementById("expenseBody");
            obj.innerHTML = "";
            if( DT.length < 1 ){
                var TR = document.createElement('TR');
                TR.innerHTML = "<td colspan=4 style='text-align:center'>이달에 등록된 지출내역이 없습니다.</td>";
                obj.appendChild(TR);
                document.getElementById("excpenseinputlist_ContDiv").style.display="block";
                return;
            }
            document.getElementById("excpenseinputlist_ContDiv").style.display="block";
            for (var i = 0; i < DT.length; i++ ){
                var chit = DT[i];
                var eano = chit.ex_num;
                var ex_title = chit.ex_title;
                var ex_type = chit.ex_type;
                var date_start = chit.date_start;
                var date_end = chit.date_end;
                var reg_date = chit.reg_date;
                var ex_mount = Util.formatNumber(chit.ex_mount);
                var car_uniqnum = chit.car_plate;
                var main_type = chit.main_type;
                if (ex_type != "3" ) main_type = chit.ex_titsub;
                if (ex_type != "3" ) car_uniqnum = chit.ex_titsub;
                ex_type == "1" ? window.ex_types = "매달" : window.ex_types ="한번";
                main_type = Util.escapeHtml(main_type);
                if( ex_type == "3") main_type = "<font style='color:var(--diary-sun)'>" + main_type + "</font>"
                var TR = document.createElement('TR');
                TR.setAttribute("onclick", "showExpense_Detail(" + eano + ")");
                var htms = "<td>" + Util.escapeHtml(ex_title) + "</td><td>" + ex_mount + "</td><td>" + main_type + "</td><td>" + Util.escapeHtml(car_uniqnum) + "</td>";
                var infos = ex_title + "|" + ex_mount + "|" + ex_type + "|" + date_start + "|" + date_end + "|" + chit.ex_titsub;
                TR.innerHTML =htms;
                obj.appendChild(TR);
                TR = document.createElement('TR');
                TR.setAttribute("style", "display:none");
                TR.setAttribute("id", "expenseTR" + eano);
                TR.setAttribute("class", "expenseTRAll");
                htms = "<td colspan=4>";
                htms += "<table style='width:100%; table-layout:fixed; border-collapse:collapse; white-space:nowrap'>";
                if( ex_type == "3"){
                    htms += "	<tr style='background-color:var(--diary-headrow-bg)'>";
                    htms += "		<td style='text-align:center'>작업일</td>";
                    htms += "		<td style='text-align:center'>" + date_start.replace(/-/gi,"/") +"</td>";
                    htms += "		<td style='text-align:center'>등록일</td>";
                    htms += "		<td style='text-align:center;width:130px'>" + reg_date.replace(/-/gi,"/") +"</td>";
                    htms += "	</tr>";
                    //htms += "	<tr><td>~</td><td>" + date_end.replace(/-/gi,"/") +"</td></tr>";
                }else{
                    htms += "	<tr><td>시작일</td><td>" + date_start.replace(/-/gi,"/") +"</td></tr>";
                    htms += "	<tr><td>종료일</td><td>" + date_end.replace(/-/gi,"/") +"</td></tr>";
                    htms += "	<tr datas='" + Util.escapeHtml(infos) +"'>";
                    htms += "		<td colspan=2 style='text-align:center ; height:40px'>";
                    htms += "			<input type='button' value='삭제' onclick='deleteexpenseSet(" + eano + ")' style='width:55px; padding:3px'>";
                    htms += "			<input type='button' value='수정' onclick='EditexpenseSet(" + eano + ", this)' style='width:55px; padding:3px'>";
                    htms += "		</td>";
                    htms += "	</tr>";
                }
                htms += "</table>";
                htms += "</td>";
                TR.innerHTML =htms;
                obj.appendChild(TR);
            }
            //document.getElementById("excpenseinputlist_ContDiv").style.display="none";
        }});
}

function check_extypeset(){
    var yy = document.getElementById("calender_yearval").value;
    var mm = Util.number_to_withzero(document.getElementById("calender_monthval").value,2);
    var thisM = yy + "-"  + mm + "-02";
    if( document.getElementById("expensetypeB").checked==true ){
        document.getElementById("dateTitlebTR").style.display="none";
        document.getElementById("dateTitlea").innerHTML = "지출일자";
        document.getElementById("expensestart").value = window.lastCallShowDay;
        document.getElementById("expenseend").value = window.lastCallShowDay;
    }else if(document.getElementById("expensetypeA").checked==true ){
        if( document.getElementById("expensestart").value.length < 10 ){
            document.getElementById("expensestart").value = thisM;
        }
        document.getElementById("dateTitlea").innerHTML = "지출시작";
        document.getElementById("expenseend").value = "2030-12-25";
        document.getElementById("dateTitlebTR").style.display="table-row";

        if( document.getElementById("expenseend").value.length < 10 ){

        }
    }
}

function carDriverSet_Driver(tar){
    obj_stylechangte("cardsetdiv2", "var(--diary-surface)");
    tar.style.backgroundColor="var(--diary-card-sel-bg)";
    var no = tar.getAttribute("data_dno");
    var na = tar.getAttribute("data_dname");
    console.log( tar );
    console.log( no + " /  "+ na );

    document.getElementById("selrealtimeondirvername").value=na;
    document.getElementById("selrealtimeondirverno").value=no;
    console.log( document.getElementById("selrealtimeondirverno").value );
}
function carDriverSet_Car(tar){
    obj_stylechangte("cardsetdiv1", "var(--diary-surface)");
    tar.style.backgroundColor="var(--diary-card-sel-bg)";
    var no = tar.getAttribute("data_cno");
    var na = tar.getAttribute("data_cplate");
    document.getElementById("selrealtimeoncarplate").value=na;
    document.getElementById("selrealtimeoncarno").value=no;
}
function obj_stylechangte(chTar, cc){
    var obj = document.getElementById(chTar);
    var inputs = obj.getElementsByTagName("div");
    for (var i=0; i < inputs.length ; i++ ){
        inputs[i].style.backgroundColor=cc;
    }
}

function page_chnage(){
    memoPopHide();
    var obj = document.getElementById("PageMoveLoading");
    if( obj){
        obj.style.display="block"; // 인디케이터는 CSS(.jb-spin) — 예전처럼 img src 를 갈아끼우지 않는다
    }
}
function page_unchange(){
    memoPopShow();
    $('#PageMoveLoading').hide();
}
function carDriverSetdone(murl){
    document.location.href=murl;
}

/**
 * 배차취소 버튼 누를때
 * @param order_num 오더번호
 * @param acttype
 * @param od_typeseval 오더타입(order_type)
 * @param selnum
 * @param thisPee 수수료율
 */
/**
 * 발주자의 취소 창 (일지 카드 > 배차취소·작업취소) — 수주 취소(F/Diary/CancelChoice)와 같은 공용 Dialog.
 *
 * 예전엔 인라인 스타일로 짠 메모팝업(작업선택 / 재접수·작업취소)을 띄우고, 고르면 swalert 로 한 번 더 물었다.
 * 고를 것과 그 뜻을 세워 두고 고르면 그 자리에서 확인 문구가 바뀌므로 창 하나로 끝낸다.
 *
 * @param order_num   오더번호
 * @param acttype     1=배차취소(수주자 있음) / 2=작업취소 (OrderPolicyService 의 버튼이 넘긴다)
 * @param od_typeseval 오더 종류 — 93 교환은 취소만, 94 외부는 '내용만 수정' 을 더 준다
 */
function confirm_cancelorder_select_05(order_num,acttype,od_typeseval,selnum, thisPee){
    set_selectedNumAgain(selnum);
    window.handle_orderNum = parseInt(order_num);
    const isDispatch = parseInt(acttype,10) === 1;
    const emph = isDispatch ? '반드시 수주자와 통화한 뒤 취소하세요' : '취소하면 되돌릴 수 없습니다';

    // 교환오더 — 고를 것이 취소뿐이라 확인창으로 직행
    if( String(od_typeseval) === '93' ){
        $j.Ui.Dialog.open({
            tone: 'danger', title: '교환오더를 취소할까요?', emph,
            confirm: '교환오더 취소', cancel: '닫기',
            onConfirm: () => order_Cancel_Do(),
        });
        return;
    }

    const choices = [
        {
            label:   '취소하고 재발주',
            tag:     '내용을 고쳐 다시 접수',
            tone:    'brand',
            rows:    [{ k:'이 오더', v:'취소' }, { k:'다음', v:'발주 화면에서 수정 후 접수' }],
            confirm: '취소 후 재발주',
            onPick:  () => order_cancel_edit_order(),
        },
        {
            label:   isDispatch ? '배차 취소' : '오더 취소',
            tag:     '이 오더를 끝냄',
            tone:    'bad',
            rows:    isDispatch
                ? [{ k:'이 오더', v:'취소', tone:'danger' }, { k:'수주자', v:'취소 알림을 받음' }]
                : [{ k:'이 오더', v:'취소', tone:'danger' }],
            confirm: isDispatch ? '배차 취소' : '오더 취소',
            onPick:  () => order_Cancel_Do(),
        },
    ];
    // 외부배차 오더는 취소 없이 내용만 고칠 수 있다
    if( String(od_typeseval) === '94' ){
        choices.unshift({
            label:   '내용만 수정',
            tag:     '취소 없음',
            tone:    'good',
            rows:    [{ k:'이 오더', v:'그대로' }],
            confirm: '수정하러 가기',
            onPick:  () => { location.href = `/m/bal?mode=myorderedit&editnum=${order_num}`; },
        });
    }

    $j.Ui.Dialog.open({
        tone:    'danger',
        title:   isDispatch ? '배차 취소' : '작업 취소',
        emph,
        confirm: '방법을 고르세요',
        cancel:  '닫기',
        choices,
    });
}
function set_selectedNumAgain(nxxn){
    var n =  parseInt(nxxn,10);
    if(nxxn==0 || isNaN(n)) { Util.swalert("열린창정보가 없습니다",""); return;}
    window.openDetail = n;
}

/**
 * 오더취소 요청 — 이 화면의 취소 세 곳(배차·작업취소, 취소 후 발주수정, 예약오더 취소)이 같이 쓴다.
 * 카드결제 진행 중인 오더면 서버가 한 번 묻게 한다(confirm) — 확인하면 card_pending_ok 를 실어 다시 보낸다
 * (CardOrderService::cancelPendingNotice, 수금완료의 card_pending_ok 와 같은 방식). 그 외 응답은 onDone 이 받는다
 */
function postOrderCancel(ordernum, onDone){
    const req = {};
    const send = () => $.ajax({type:"POST", url:`/m/ajax/order/${ordernum}/cancel`, data:req, success:function(data){
        if (data && data.confirm) {
            Util.swalert(data.message, function(){ req.card_pending_ok = 1; send(); }, ['오더취소', '닫기']);
            return;
        }
        onDone(data);
    }});
    send();
}

function order_Cancel_Do(){  // 배차취소 / 작업취소 / 교환오더취소
    const ordernum = window.handle_orderNum;
    postOrderCancel(ordernum, function(data){
        if( !data.result) {
            Util.swalert(data.message);
            return;
        }
        // 안내 없이 일지로 넘어가면 취소가 됐는지 알 수 없다. 홀드 해제·알림은 큐가 뒤따라 한다
        // 카드결제가 남은 오더면 본문에 안내를 붙인다(취소는 이미 됐다 — CardOrderService::paidNotice)
        Util.swalert(['오더가 취소되었습니다.','success', data.notice || null], () => location.replace(`/m/diary?showipicknum=${ordernum}`));
    });
}


/**
 * 오더를 취소하고 발주수정페이지로 이동
 */
function order_cancel_edit_order(){
    const ordernum = window.handle_orderNum;
    postOrderCancel(ordernum, function(data){
        if( !data.result) {
            Util.swalert(data.message);
            return;
        }
        location.href=`/m/bal?mode=otherorder&editnum=${ordernum}`;
    });

}

function make_getinfos(){/////////////////////////
    var n = window.openDetail;
    if( isNaN(parseInt(window.openDetail))){ Util.swalert("선택된 항목없습니다","");return;		}
    if( ! document.getElementById("myordernum" + n)){
        Util.swalert(n + " 번째 정보가 없습니다.","");
        return -1;
    }
    window.handle_orderNum =			document.getElementById("myordernum" + n).value;		 //////////////////////////// 이부분 에러 난곳
    window.eaoinfo_order_address =	document.getElementById("eaoinfo_order_address" + n).value;
    window.xorder_worker_num =	document.getElementById("eaoinfo_orderworkernum" + n).value;
    window.xorder_mem_num =	document.getElementById("eaoinfo_ordermemnum" + n).value;
    window.eaoinfo_order_address = window.eaoinfo_order_address.replace(/&/gi, "n");
}


function put_value_infos(datas){
    var s = datas.split("&");
    page_chnage();
    for (var i=0; i< s.length ;i++ ){
        var chit =  s[i];
        if (chit.length > 1){
            var ea = chit.split("=");
            var ea_hd = ea[0];
            var ea_va = ea[1];
            var eatar = eval("document.workflow." + ea_hd);
            if(eatar){
                eatar.value=ea_va;
            }else{
            }
        }
    }
}
function reservOrderCancel(ordernum){
    if(isNaN(parseInt(ordernum))){
        Util.swalert("오더 고유번호값이 없거나 잘못되었습니다");
        return;
    }
    Util.swalert(["선택한 오더를 취소 하시겠습니까?\n취소된 오더는 리스트의 맨아래에서 확인 가능합니다.",'question'],()=>{
        postOrderCancel(ordernum, function(){ document.location.reload(); });
    },['네','아니오']);
}

/**
 * 현장도착
 * @param pointX
 */
function send_field_arrival_noty(pointX){
    make_getinfos();
    var mtitle = "현장도착"
    var msgg = "[장비불러] 현장 도착 내용이 있습니다.<br>"
    msgg += "현장 도착완료<br>";
    msgg += window.eaoinfo_order_address + "<br>";
    var mOK_Msg = "발주자에게 현장 도착했음을 통지했습니다.";
    // var datas = "ptype=order_current_communicating&notitype=fieldarrival&mtitle=" +mtitle+ "&sender_num=" + xorder_worker_num + "&ordernum=" + handle_orderNum + "&pointX=" + pointX;
    // datas += "&recivernum=" + xorder_mem_num + "&msg=" + msgg + "&linkurl=" + linkurl + "&OKMSG=" + mOK_Msg+"&returl=" + returl + "&notiTypedetail=현장도착";
    // put_value_infos(datas);
    // document.workflow.submit();
    const ordernum = window.handle_orderNum;
    var adr = `/m/ajax/order/${ordernum}/arrive`;
    $.ajax({type:"POST", url:adr , success:function(data){
            if( data && data.result === false ){ Util.swalert([data.message, 'warning']); return; }
            Util.swalert(mOK_Msg, function(){
                location.href=`/m/diary?showipicknum=${ordernum}`;
            })
        }});

}

function ready_send_arrival(selnum,worktime){
    var pointX = 0;
    var obj = document.getElementById("eaoinfo_ordertype" + selnum);
    var order_typeset = "";
    if( obj) order_typeset = obj.value;
    //order_typeset = "0";
    if( order_typeset != "0" ){
        pointX = 0;
        window.mgg = "현재 오더를 현장 도착으로 설정할까요?";
    }else{
        window.mgg = "현재 오더를 현장 도착으로 설정할까요?";
        var dt = new Date(worktime);
        var nn = new Date();
        var ss = parseInt( (dt - nn) / 60000);
        //console.log( "작업시간:" + worktime + " /  현시간 :" + nn + " / 남은 분 : " + ss );

        var tts = "<small><font style='color:black;font-size:16px;line-height:20px'>배차완료 => 현장 작업중 설정할까요?<br></font><font style='color:blue;font-size:13px'>";
        //mgg = tts + "작업시간 지남 (예상 수주포인트 <font style='color:red;'>0점<font style='color:black'>)</font></small>" ;//"배차상태 => 현장 작업중\n설정할까요?\n\n작업시간 지남 (예상 수주포인트 0점)";
        if( ss <= 40 && ss >=0 ) {
            //mgg = tts + "작업시간 40 이내 (예상 수주포인트 <font style='color:red;'>10점<font style='color:black'>)</font></small>";//배차상태 => 현장 작업중\n설정할까요?\n\n작업시간 40 이내 (예상 수주포인트 10점)";
            pointX = 10;
        }else if (ss > 40 ){
            //mgg = tts + "작업시간 40 분전 부터 작업시간 전까지<br>현장도착 클릭시 작업 포인트 10점 적립.<br><font style='color:black;font-size:13px'>(작업시간 " + ss + "분전 예상 수주포인트 <font style='color:red;'>0점<font style='color:black'>)</font></small>";
        }
    }
    set_selectedNumAgain(selnum)
    window.confirm_ok_act = "ready_send_arrivalOK";
    Util.swalert([window.mgg, 'question'],()=>{
        send_field_arrival_noty(pointX);
    },['네','아니오'])
}
/**
 * 수금완료 처리
 * @param workmoden (2:수금완료)
 */
function work_done_infos_confirm_Btn_OK(workmoden){
    if( make_getinfos() == -1 ) {
        return;
    }
    var mynumobj = document.getElementById("mynum");

    var mtitle = "수금완료"
    var msgg = "[장비불러] 수금완료 내용이 있습니다.<br>"
    msgg += "수금완료<br>";
    msgg += window.eaoinfo_order_address;
    var mOK_Msg = "발주자에게 수금완료를 통지했습니다.";
    // var datas = "ptype=order_current_communicating&notitype=paymentdone&mtitle=" +mtitle+ "&sender_num=" + xorder_worker_num + "&ordernum=" + handle_orderNum + "&recivernum=" + xorder_mem_num;
    const ordernum = window.handle_orderNum;
    var adr = `/m/ajax/order/${ordernum}/pay-done`;
    const data = {};
    const send = () => $.ajax({type:"POST", url:adr , data, success:function(res){
            // 카드결제 결과 확인 중인 오더 — 한 번 묻고, 확인하면 그대로 수금완료한다 (CardOrderService::pendingNotice)
            if (res && res.confirm) {
                Util.swalert(res.message, function(){ data.card_pending_ok = 1; send(); }, ['수금완료', '취소']);
                return;
            }
            if (res && res.result === false) { Util.swalert(res.message || '처리하지 못했습니다.'); return; }
            Util.swalert(mOK_Msg, function(){
                location.href=`/m/diary?showipicknum=${ordernum}`;
            })
        }});
    send();

}
/////////////////////////////////////////////▲▲▲▲▲▲▲작업 종료 요청 / 작업 종료 알림▲▲▲▲▲▲▲▲/////////////////////////

function addPhotoPrepare(ordernum){
    if( MEMBER['mem_ownercode']!=ORDER['worker_owner_num'] && ['0','95'].includes(ORDER['order_type']) && !G5['isAdmin'] ){
        $j.Common.Util.tsalert('warning','수주자만 접근 가능합니다.');
        return;
    }
    $j.Ui.BS.open({ target: '$j.F.Diary.DiaryPhotoHub', fixedHeight: true, data: { ordernum: ORDER['num'], tab: 'doc', visibleTabs: ['doc', 'photo'] } });
}

/**
 * 오더별 캐시내역 보기
 * @param ordernum
 */
// 캐시내역 시트 — 구현은 F/Diary/CashLog 로 이관. 인라인 onclick 호환용 브리지.
function cash_view(ordernum){
    $j.F.Diary.CashLog.open(ordernum);
}

// 작업흐름 요청(현장도착/작업취소/작업종료/수금완료) 완료 후 이동.
// 레거시 푸시처리 페이지 하단 리다이렉트 로직 이전 (listtype=subbuller 면 일지상세, 아니면 목록).
function pushReq_redirect(orderThisNum){
    var lt = (document.workflow && document.workflow.listtype) ? document.workflow.listtype.value : "";
    var url = (lt == "subbuller")
        ? "/m/diary?showipicknum=" + orderThisNum
        : "/m/diary/list?showipicknum=" + orderThisNum;
    location.replace(url);
}

function send_field_arrival_request(selnum){
    set_selectedNumAgain(selnum)
    if( make_getinfos() == -1 ) return;
    $.ajax({type:'POST', url:"/m/ajax/order/" + window.handle_orderNum + "/request/field-arrival", dataType:'json',
        success:function(r){ if(r.result) pushReq_redirect(window.handle_orderNum); else Util.swalert([r.message,'warning']); }});
}

function ask_cancelorder_check(selnum){
    set_selectedNumAgain(selnum);
    $j.Ui.Dialog.open({
        tone:    'info',
        title:   '발주자에게 취소 요청할까요?',
        emph:    '발주자와 꼭 통화하세요',
        confirm: '요청',
        cancel:  '닫기',
        onConfirm: () => ask_cancelorder(),
    });
}

function ask_cancelorder(){
    make_getinfos();
    $.ajax({type:'POST', url:"/m/ajax/order/" + window.handle_orderNum + "/request/job-cancel", dataType:'json',
        success:function(r){ if(r.result) pushReq_redirect(window.handle_orderNum); else Util.swalert([r.message,'warning']); }});
}

/**
 * 수주 취소요청 실행 — 확인은 부르는 쪽이 이미 받았다.
 * (취소 방법 선택창이 설명·버튼문구로 확인을 겸하므로 창을 한 번 더 띄우지 않는다)
 */
function ask_cancelorder_run(selnum){
    set_selectedNumAgain(selnum);
    ask_cancelorder();
}

/** 페널티 취소 실행 — 확인은 부르는 쪽이 이미 받았다 */
function panalty_cancelorder_run(n){
    if( isNaN(parseInt(n)) ) { Util.swalert(["취소할 오더값이 없습니다",'warning']); return; }
    window.panalty_orderNum = n;
    $.ajax({
        url: `/m/ajax/order/${n}/penalty-cancel`,
        type: 'post',
        dataType: 'json',
        success: function(data){
            if( data.result>0 ){
                // 안내 없이 일지로 넘어가면 취소가 됐는지 알 수 없다. 포인트 차감·재발주는 큐가 뒤따라 한다
                Util.swalert(['페널티취소 되었습니다.\n수주포인트 200점이 차감되고, 오더는 다시 발주됩니다.','success'],
                    () => location.replace('/m/diary?showipicknum='+n));
            }
            else Util.swalert([data.message,'warning']);
        }
    });
}

/** 페널티 취소 — 고를 것이 이것뿐인 자리(임의수주)에서 쓰는 확인창 */
function panalty_cancelorder(n){
    if( isNaN(parseInt(n)) ) {
        Util.swalert(["취소할 오더값이 없습니다",'warning']); return;
    }
    $j.Ui.Dialog.open({
        tone:    'danger',
        title:   '바로 취소할까요?',
        emph:    '발주자와 꼭 통화하세요',
        // 페널티는 두 가지다 — 수수료(10%)와 수주포인트 200점 (OrderCancellationService::cancelByPenalty)
        notes:   [{ k:'페널티',    v:'발주대금 10%' },
                  { k:'수주포인트', v:'200점 차감' }],
        confirm: '바로 취소',
        cancel:  '닫기',
        onConfirm: () => panalty_cancelorder_run(n),
    });
}
// 수주 취소 방법 선택 — 구현은 F/Diary/CancelChoice(BS 시트) 로 이관. 인라인 onclick 호환용 브리지.
function selectOrderToCancel_ask(orderNo, order_type){
    $j.F.Diary.CancelChoice.open(orderNo, order_type);
}

function send_job_done_request(selnum){
    set_selectedNumAgain(selnum)
    make_getinfos();
    $.ajax({type:'POST', url:"/m/ajax/order/" + window.handle_orderNum + "/request/job-done", dataType:'json',
        success:function(r){ if(r.result) pushReq_redirect(window.handle_orderNum); else Util.swalert([r.message,'warning']); }});
}

function reqest_paymentdone(selnum){
    set_selectedNumAgain(selnum)
    make_getinfos();
    $.ajax({type:'POST', url:"/m/ajax/order/" + window.handle_orderNum + "/request/payment-done", dataType:'json',
        success:function(r){ if(r.result) pushReq_redirect(window.handle_orderNum); else Util.swalert([r.message,'warning']); }});
}
function input_by_contact(n,s){
    var mg = "본 오더를 [" + s + "] 으로 처리할까요?";
    Util.swalert([mg, 'question'],()=>{
        $.ajax({type:'POST', url:"/m/ajax/order/" + n + "/contract-input", data:{setstatus:s}, dataType:'json',
            success:function(r){ if(r.result) location.replace(r.redirect); else Util.swalert([r.message,'warning']); }});
    },['네','아니오']);
}

var photoJobPoint = 0;
var last_order_chnum = 0;
// 구 app_Ver_Reset(ver) (앱이 버전을 알려주던 진입점) 은 2026-08 제거 — 앱 발화 0건이고
// 앱버전은 $j.F.App.getVersion() 동기 조회로 얻는다.

/**
 * 일지에서 작업사진을 업로드 한다.
 * @param tag (diary1:현장사진, diary2:작업문서)
 */
function addphotoHere(tag='diary1'){
    window.photoUPOrderNum = Util.int( ORDER['num']);
    $j.F.Upload.addPhotoHere({
        tag: tag,
        context: 'diaryPhoto:'+tag,
        max_sheet: 5,
        id: ORDER['num'],
    });
}

/**
 * 파일 업로드 후 비즈니스로직
 * @param file : {id,host,path,  date, gps, address} 또는 배열
 * [{'id":1103627,'path":"2026/04/15/69df14965c157.jpg"
 * ,"host":"https://img jbbuller.net"
 * ,"type":"I"
 * ,"date":"2026:04:15 13:31:13"
 * ,"gps":"37.402320861816406, 126.95439910888672"
 * ,"address":"경기 도 안양시 동안구 관악대로 282"
 * }]
 */
function updateWorksPhoto(file, tag){
    console.log('updateWorksPhoto', file, tag);
    const ordernum = ORDER['num'];
    const data = {
        type : tag,
        files : (Array.isArray(file) ? file : [file]),
    };

    $.ajax({
        type: 'POST',
        url: `/m/ajax/order/${ordernum}/photos`,
        data,
        success: function (r) {
            if( r.result != true){
                $j.Common.Util.tsalert('warning','처리중 오류가 발생하였습니다.');
                return;
            }
            location.href=`/m/diary?showipicknum=${ordernum}`;
        }
    });
}

// 구 uploadDone(orderNo) (작업사진 전송 완료 시 앱이 직접 호출) 은 2026-08 제거 —
// 업로드 완료는 broker 콜백 callbackUploadImage → EventBus 'upload:image' 구독자가 처리한다.

// 지출입력 시트 — 구현은 F/Diary/ExpenseForm 으로 이관. 인라인 onclick 호환용 브리지.
function add_expances(orderNum,editNum){
    $j.F.Diary.ExpenseForm.open(orderNum, editNum);
}

/**
 * MY 메모 시트 — 구현은 F/Diary/WorkMemo 로 이관. 인라인 onclick 호환용 브리지.
 */
function add_workMemos(orderno){
    $j.F.Diary.WorkMemo.open(orderno);
}

/**
 * 기사및 업체등록 팝어
 * @param ordernum
 */
// function regthingPopshow(ordernum){
//     var my_num = user_loginNum;
//     var mem_ownercode = user_ownerNum;
//
//     var adr = "/_sky_m_05_register_all.php";
//     var datas = {"ordernum" : ordernum , "my_num" : my_num ,"mem_ownercode":mem_ownercode,"mem_permit":mem_permit}
//     $.ajax({
//         type : 'GET',url : adr,data : datas ,success : function (data) {
//             // document.getElementById("memoinputmoreTop").style.display="block";
//             // document.getElementById("memoinputmore").style.display="block";
//             // document.getElementById("memoinputmore").innerHTML = data;
//             $j.Common.Util.modal(data);
//         }
//     });
// }
// function check_typeset(obj){
//     var ss = ["","특차기사","수주제한","악덕업체"];
//     var mg = ss[obj.value];
//     var x1 = document.getElementById("thisregtypeme").value;
//     var x2 = document.getElementById("eeTypeasv").value;
//
//     var fname = document.getElementById("contract_name").value;
//     var cnums = document.getElementById("contract_number").value;
//     var fnums = document.getElementById("reg_contract_fieldnumber").value;
//
//     var thisOd_baljoo_num =		parseInt(document.getElementById("thisOd_baljoo_num").value,10);
//     var thisOd_baljoo_name =	document.getElementById("thisOd_baljoo_name").value;
//     var thisOd_baljoo_id =		document.getElementById("thisOd_baljoo_id").value;
//
//     var thisOd_soojoo_num =		parseInt(document.getElementById("thisOd_soojoo_num").value,10);
//     var thisOd_soojoo_name =	document.getElementById("thisOd_soojoo_name").value;
//     var thisOd_soojoo_id =		document.getElementById("thisOd_soojoo_id").value;
//
//     var thisOrderNum = document.getElementById("this_regall_ordernum").value;
//     //user_loginNum  user_ownerNum
//
//     var n = parseInt(obj.value,10);
//     if( n == 1){
//         if( user_loginNum == thisOd_baljoo_num || user_ownerNum ==thisOd_baljoo_num){
//             var T1 = document.getElementById("rowTab2");
//             var T2 = document.getElementById("rowUP2");
//             var Tab1 = document.getElementById("TabInside2");
//             TR_row_hide(['rowTab1','rowTab3','rowTab4','rowUP1','rowUP3','rowUP4']);
//             var Btn = "<input type='button' value='이 수주자를 특차등록'  style='width:100%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(0,"+ thisOd_soojoo_num +",'"+thisOd_soojoo_id+"','"+thisOd_soojoo_name+"')" + String.fromCharCode(34)+">";
//         }else{
//             var T1 = document.getElementById("rowTab1");
//             var T2 = document.getElementById("rowUP1");
//             var Tab1 = document.getElementById("TabInside1");
//             var Btn = "<input type='button' value='이 발주자를 특차등록'  style='width:100%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(0,"+ thisOd_baljoo_num +",'"+thisOd_baljoo_id+"','"+thisOd_baljoo_name+"')" + String.fromCharCode(34)+">";
//             TR_row_hide(['rowTab2','rowTab3','rowTab4','rowUP2','rowUP3','rowUP4']);
//         }
//
//         T1.style.display="table-row";
//         T2.style.display="table-row";
//         Tab1.innerHTML = Btn;
//     }else if( n == 2){
//         if( user_loginNum == thisOd_baljoo_num || user_ownerNum ==thisOd_baljoo_num){
//             var T1 = document.getElementById("rowTab2");
//             var T2 = document.getElementById("rowUP2");
//             var Tab1 = document.getElementById("TabInside2");
//             var Btn1 = "<input type='button' value='수주제한'  style='width:45%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(1,"+ thisOd_soojoo_num + ",'" +thisOd_soojoo_id + "','" + thisOd_soojoo_name +"',1)" + String.fromCharCode(34)+">";
//             var Btn2 = "<input type='button' value='수발주제한'  style='width:45%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(1,"+ thisOd_soojoo_num + ",'"+thisOd_soojoo_id+"','"+thisOd_soojoo_name+"',3)" + String.fromCharCode(34)+">";
//             TR_row_hide(['rowTab1','rowTab3','rowTab4','rowUP1','rowUP3','rowUP4']);
//         }else{
//             var T1 = document.getElementById("rowTab1");
//             var T2 = document.getElementById("rowUP1");
//             var Tab1 = document.getElementById("TabInside1");
//             var Btn1 = "<input type='button' value='수주제한'  style='width:43%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(1,"+ thisOd_baljoo_num + ",'"+thisOd_baljoo_id+"','"+thisOd_baljoo_name+"',1)" + String.fromCharCode(34)+">&nbsp;&nbsp;";
//             var Btn2 = "<input type='button' value='수발주제한'  style='width:43%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(1,"+ thisOd_baljoo_num + ",'"+thisOd_baljoo_id+"','"+thisOd_baljoo_name+"',3)" + String.fromCharCode(34)+">";
//             TR_row_hide(['rowTab2','rowTab3','rowTab4','rowUP2','rowUP3','rowUP4']);
//         }
//         Tab1.innerHTML = Btn1 + Btn2;
//         T1.style.display="table-row";
//         T2.style.display="table-row";
//     }else if( n == 3){
//         var T1 = document.getElementById("rowTab3");
//         var T2 = document.getElementById("rowTab4");
//         var T3 = document.getElementById("rowUP3");
//         var T4 = document.getElementById("rowUP4");
//
//         TR_row_hide(['rowTab1','rowTab2','rowUP1','rowUP2']);
//
//         var Btn1 = "<input type='button' value='위 거래처 악덕등록'  style='width:90%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(2,"+ thisOrderNum + ",'" + fname + "','"+cnums+"',1)" + String.fromCharCode(34)+">&nbsp;&nbsp;";
//         var Btn2 = "<input type='button' value='위 현장 악덕등록'  style='width:90%;height:40px' class='m5_btn' onclick=" + String.fromCharCode(34) + "reg_inofs_tolist(2,"+ thisOrderNum + ",'" + fname + "','"+fnums+"',2)" + String.fromCharCode(34)+">";
//         var Tab1 = document.getElementById("TabInside3");
//         var Tab2 = document.getElementById("TabInside4");
//         T1.style.display="table-row";
//         T2.style.display="table-row";
//         T3.style.display="table-row";
//         T4.style.display="table-row";
//         Tab1.innerHTML = Btn1;
//         Tab2.innerHTML = Btn2;
//     }
// }
function TR_row_hide(obj){
    for (var i = 0; i < obj.length; i++ ){
        var T1 = document.getElementById(obj[i]);
        if(T1) T1.style.display="none";
    }
}

function reg_inofs_tolist(ty,num,num2,num3,act){
    var thisOrderNum = document.getElementById("this_regall_ordernum").value;
    var workInfos = document.getElementById("workInfos").value;
    var goAdr = "";
    if( user_loginNum == num){
        Util.swalert("본인이 본인을 등록할 수 없습니다.",""); return;
    }
    if( num2.length > 5 || num3.length > 5 ){
        if( ty==0){
            goAdr = "/m/relation/special?ordernum=" + thisOrderNum + "&usernum=" + num + "&userid=" + num2 + "&username=" + num3;
        }else if( ty==1){
            goAdr = "/m/relation/limit?ordernum=" + thisOrderNum + "&usernum=" + num + "&userid=" + num2 + "&username=" + num3 + "&regtype=" + act;
        }else if( ty==2){
            goAdr = "/m/relation/devil?ordernum=" + thisOrderNum + "&coname=" + num2 + "&cophone=" + num3 ;
        }
    }
    if( goAdr != ""){
        document.location.href=goAdr;
    }else{
        Util.swalert("등록 정보를 받지 못했습니다.",""); return;
    }
}

/**
 * 결제책임 변경 모달띄우기
 * @param orderNo
 * @param howtopay
 * @param sign_howlong_int
 * @returns {boolean}
 */
function soojooPeeChangeDo(orderNo,howtopay, sign_howlong_int){
    payMentchangeOrdernum = orderNo;
    $j.Ui.BS.open({
        target: '$j.F.Baljoo.ModalHowToPay',
        fixedHeight: true,
        data: {
            howtopay,
            sign_howlong_int,
            onApply: (data) => {
                payment_ChangeDo(data['howtopay'], data['sign_howlong_int']);
            },
        },
    });
    return false;
}


function opt_selectPosshowx(str,act, topp){
    var objin = document.getElementById("calenderin");
    var obj = document.getElementById("crd");
    objin.innerHTML = str + "<br><br><Br>";
    if( topp == undefined) topp = 50;

    obj.style.display="block";
    obj.style.visibility = "visible";
    objin.style.backgroundColor="var(--diary-surface)";
    objin.style.position="fixed";
    objin.style.top="30%";
    objin.style.width="95%";
    objin.style.left="2%";
    var D = document;
    var wwx = parseInt(D.body.clientWidth * 0.95,10);
    var gga =  parseInt((D.body.clientWidth - wwx) / 2 ,10);
    obj.style.width=wwx + "px";
    obj.style.left="1%";
    obj.style.top="50px";
    var tb = document.getElementById("calender_table");
    tb.style.width="90%";
    tb.style.margin="0px auto";

    document.getElementById("optmakerPrebtn").style.display="none";
    document.getElementById("optmakerNextbtn").style.display="none";
    var blk = document.getElementById("blackbgx");
    if( blk ) blk.style.display="block";
    var crd = document.getElementById("crd");
    crd.style.top = topp + "px";
    console.log( topp );
    console.log( crd );


}
var payMentchangeOrdernum = 0;
// function callback_howtopay_set(n){
//     payment_ChangeDo(n, 0, 2);
// }
// function callback_howtopay_set_sign(n){
//     $("#howtopaySignholder").show();
//     $('#howtopayway1').css('background-color','#F9CA48');
//     $('#howtopayway2').css('background-color','#E7E8EA');
//     $('#howtopayway3').css('background-color','#E7E8EA');
// }
// function callback_howtopay_set_sign_type(ndays) {
//     let nstr = sign_due_str(ndays);
//     payment_ChangeDo(nstr, ndays, 1);
// }
function payment_ChangeDo(howtopay , ndays){			///c_clear();
    payMentchangeOrdernum = parseInt(payMentchangeOrdernum);
    if( isNaN(payMentchangeOrdernum)) payMentchangeOrdernum = 0
    if( payMentchangeOrdernum < 10 ){alert("선택된 오더값이 없습니다."); return;}
    var adr = `/m/ajax/order/${payMentchangeOrdernum}/howtopay`;
    var sendData = {};
    sendData["howtopay"] = howtopay;
    sendData["sign_howlong_int"] = ndays;
    $.ajax({type:"POST",
        url:adr ,
        data:sendData,
        success:function(data){
            if( !data.result ){
                alert(data.message);
                return;
            }
            document.location.href="?showipicknum=" + payMentchangeOrdernum;
        }});
}
/**
 * 수주자가 금액을 바꾸기 전에 받는 협의 확인.
 *
 * 금액은 발주자와 수주자 사이의 합의값인데, 일지에서는 수주자가 혼자 고칠 수 있다.
 * 협의 없이 올린 금액이 그대로 정산까지 가면 분쟁이 CS 로 온다 — 그래서 바꾸기 전에
 * '협의했다'를 손으로 받는다. 체크 전에는 [동의·수정] 이 잠긴다($j.Ui.Dialog 의 agree).
 *
 * 발주자(smode=1)에게는 띄우지 않는다 — 자기 오더의 금액이라 협의의 주체가 다르다.
 * @return {Promise<boolean>} 동의하면 true
 */
function confirmPriceChangeBySoo(){
    return $j.Ui.Dialog.open({
        tone:    'danger',
        title:   '발주자와 협의 후 변경하세요',
        // 제목 아래 보조문장을 두지 않는다 — 읽어야 할 덩어리가 셋(제목·보조문·경고문)이면
        // 정작 손으로 눌러야 할 체크박스가 맨 아래로 밀린다. 통지 사실은 hint 한 줄로.
        agree:   {
            noteHtml: '미협의로 생긴 분쟁·손해는 <b>본인</b> 책임입니다',
            label:    '협의 완료, 위 내용 동의',
        },
        hint:    '변경 내용은 발주자에게 통지됩니다',
        confirm: '변경',
        cancel:  '취소',
    });
}

function car_price_Change(ordernum, smode, evt){ ///////// 금액변경
    if( ORDER['num']!=ordernum ) return; // 오더가 안 펼쳐진상태에서 도착시간을 클릭하면 아무반응 없게
    // if( mem_driver_type=='업체발주자' && !is_admin){
    //     swalert("금액 변경이 불가합니다.");
    //     return;
    // }
    if( window.handle_orderNum != ordernum){
        return ;
    }
    if(evt){
        evt.preventDefault();
        evt.stopPropagation();
    }

    // 수주자면 협의 확인을 먼저 받는다. 횟수제한(서버)을 통과한 뒤에 물어야
    // '동의했는데 못 바꾼다'는 순서가 안 생긴다.
    const openPriceModal = async () => {
        if (Util.int(smode) !== 2) { _openPriceModal(false, smode); return; }
        if (!(await confirmPriceChangeBySoo())) return;
        _openPriceModal(true, smode);// 동의는 저장요청까지 실어 처리이력에 남긴다
    };

    if( ['0','95'].includes(ORDER['order_type'])){
        const type = smode==1?'price-bal':'price-soo';
        $.ajax({
            type: "GET",
            url: `/m/ajax/order/${ordernum}/change-limit`,
            data: {table:'order', id:ordernum, type},
            success: (data) => {
                if (data.change_count>=5) {
                    alert('금액변경은 5회로 제한됩니다. 사무실로 문의해 주세요');
                    return;
                }
                openPriceModal();
            }
        });
    }else{
        openPriceModal();
    }
}


/**
 * 현장 도착 시간 변경 다이얼로그
 * @param ordernum 오더번호
 * @param work_time
 * @param el
 */
function _openPhoneModal($p, onApply){
    $j.Ui.BS.open({
        target: '$j.F.ModalPhone',
        // 소속자 탭은 소속기사+소유차량 리스트(49rem)가 길어 BS auto-height 로는
        // 화면을 벗어나 스크롤이 닿지 않는다. 95vh 로 고정해 내부 스크롤이 잡히게 한다.
        fixedHeight: $p['why'] === '소속자',
        data: {
            $p,
            onApply: ($r) => {
                if (!ORDER.$r) ORDER.$r = {};
                Object.assign(ORDER.$r, $r);
                if (!ORDER.$p) ORDER.$p = {};
                ORDER.$p['why'] = $p.why;
                if (typeof onApply === 'function') onApply($r);
            },
        },
    });
}

/**
 * 금액변경 모달.
 * @param negoAgree 수주자가 협의동의를 체크했는가 (서버가 처리이력에 남긴다)
 * @param smode 1:발주자 2:수주자 — 저단가 확인창의 말투가 갈린다(잃는 쪽은 늘 발주자다)
 */
function _openPriceModal(negoAgree, smode){
    $j.Ui.BS.open({
        target: '$j.F.Baljoo.ModalPrice',
        fixedHeight: true,
        data: Object.assign({}, ORDER, {
            sky_role: Util.int(smode) === 2 ? 'soo' : 'bal',
            onApply: (data) => {
                $j.Ui.BS.applySnapshot(ORDER, data);
                const dd = {jobtype: 'pricechangestarting'};
                dd['change_price_total']       = ORDER['car_price'];
                dd['change_price_total_bonsa'] = ORDER['car_price_bonsa'];
                dd['is_return']                = ORDER['is_return_job'];
                dd['jobgoobun']                = ORDER['car_workdaytype'];
                dd['jobworkhr']                = ORDER['car_workhour'];
                dd['addHourIntval']            = ORDER['add_hour'];
                dd['addHourType']              = ORDER['add_hour_type'];
                dd['addHourIntprice']          = ORDER['add_hour_price'];
                dd['nego_agree']               = negoAgree ? 1 : 0;
                $.ajax({
                    type: 'POST',
                    url:  `/m/ajax/order/${ORDER['num']}/price`,
                    data: dd,
                    dataType: 'json',
                    success(r) {
                        if (r.result) {
                            location.href = `/m/diary?showipicknum=${ORDER['num']}`;
                        } else {
                            Util.swalert(r.message);
                        }
                    },
                });
            },
        }),
    });
}

function _openWorkDayTimeModal(ordernum, work_time){
    $j.Ui.BS.open({
        target: '$j.F.Baljoo.ModalWorkDayTime',
        fixedHeight: true,
        data: {
            num: ordernum,
            work_time,
            onApply: (data) => {
                const dj = dayjs(data['work_time']);
                $.ajax({
                    type: 'POST',
                    url:  `/m/ajax/order/${data['num']}/workday`,
                    data: {
                        jobtype:    'order_date_change',
                        ordernum:   data['num'],
                        newdateval: dj.format('YYYY-MM-DD'),
                        workhour:   dj.format('HH'),
                        workminute: dj.format('mm'),
                    },
                    success() {
                        location.href = `/m/diary?showipicknum=${data['num']}`;
                    },
                });
            },
        },
    });
}

function change_dataThing(ordernum, work_time,el){
    if( ORDER['num']!=ordernum ) return; // 오더가 안 펼쳐진상태에서 도착시간을 클릭하면 아무반응 없게
    if( $(el).attr('canChangeDateTime')!=1 ){
        // 막힌 이유를 알려준다 — 무반응이면 고장인 줄 알고 CS 로 전화가 온다 (이유 코드: OrderPolicyService::dateLockReason)
        const lockMsg = {
            worker_only: '배차 후 작업일시는 수주자만 변경할 수 있습니다.',
            done:        '작업완료 이후에는 작업일시를 변경할 수 없습니다.',
            cancel:      '취소된 오더는 작업일시를 변경할 수 없습니다.',
        }[$(el).attr('data-date-lock')];
        if( lockMsg ) Util.swalert(lockMsg);
        return;
    }

    // // 어플,싸인, 작업완료후 시간변경 못하게
    // if( ORDER['order_type']==0 && ORDER['pay_method']==1 && ORDER['order_status']>=8) return;
    console.log(ORDER['order_type']);
    if( ['0','95'].includes(ORDER['order_type'])){
        $.ajax({
            type: "GET",
            url: `/m/ajax/order/${ordernum}/change-limit`,
            data: {table:'order', id:ordernum, type:'time'},
            success: (data) => {
                if (data.change_count>=5) {
                    alert('시간변경은 5회로 제한됩니다. 사무실로 문의해 주세요');
                    return;
                }
                _openWorkDayTimeModal(ordernum, work_time);
            }
        });
    }else{
        _openWorkDayTimeModal(ordernum, work_time);
    }
}


var last_goAddr_addr = "";
var last_goAddr_gps = "";

/**
 * 내비 앱 선택 모달 표시. 클릭한 주소 요소의 GPS/주소를 stash.
 * @param gps "lat,lng" 형식
 * @param adr 주소 문자열
 */
function naviCallTo(gps, adr){
    if (gps) last_goAddr_gps = gps;
    if (adr) last_goAddr_addr = adr;
    $('#selectNaviApp').show();
}

/**
 * 카카오내비 앱 실행. naviCallTo 가 stash 한 값 사용, 없으면 ORDER 폴백.
 */
function mapRunDo(){
    $('#selectNaviApp').hide();
    const gps = last_goAddr_gps || ORDER['site_latlng'];
    const addr = last_goAddr_addr || ORDER['site_address'];
    const [lat,lng] = gps.split(',').map(parseFloat);
    if(!$j.F.App.runNavi(lng,lat,addr)){
        alert("앱에서만 실행가능 합니다.");
    }
}
// 로드뷰
function showRoadView(tar){
    $j.F.App.openRoadView(ORDER['site_latlng']);
}
var call_made_ordernum = 0;

/**
 * 통화 로그 남기기
 * @param orderNum
 * @param phoneNum
 * @param act 내가누구냐 1(발주자), 2(수주자)
 * @param subact 누구랑통화했냐 logdo(발주자와 통화), ucall(소속자와통화), 빈값(소속자와 통화)
 */
function record_call_log(orderNum,phoneNum,act,subact){
    $.ajax({
        type: 'POST',
        url: "/m/ajax/order/call-log",
        data: {"callTo": phoneNum, "ordernum": orderNum, "subact": subact, "mact": act},
        success: function (data) {
            call_made_ordernum = orderNum;
            document.location.href = 'tel:' + phoneNum;

            // logdo : 발주자와 통화 시에는 일지 페이지를 새로고침하여 숨겨진 주소를 표시해준다.
            if (subact == 'logdo') {
                setTimeout(function () {
                    document.location.reload();
                }, 300);
            }
        }
    });
}
/**
 * 차량번호 배지(cir20) 클릭 → 차량번호 + 순서설정 시트
 *
 * 구 구현은 화면좌표로 띄우는 팝오버(#infosBoxshjow) 였다.
 * getBoundingClientRect()(렌더 px) 를 style.left/top(레이아웃 px) 에 그대로 넣어서
 * 큰글씨(body zoom) 에서 배율만큼 밀려나 엉뚱한 위치에 떴다 → BS 로 전환(좌표계산 자체가 없다).
 * 시그니처는 ListRenderer 의 onclick 문자열이 그대로 넘기므로 유지한다(tarobj/evt 는 이제 위치용이 아님).
 */
function show_carNumDetail(ordernum,carnum,carplate,orderstatus,tarobj,evt){
    if( evt ) evt.stopPropagation();

    var html = '<div class="carnum-sheet">'
        + '<a class="carnum-sheet__btn" href="/m/setting/gps?m=v">순서설정하기</a>'
        + '</div>';

    $j.Ui.BS.open({ target: { init() { $('#' + this.id).html(html); } } });
    $j.Ui.BS.setTitle(carplate || '차량');
    return false;
}

/**
 * 일지 일별보기 검색버튼 누를때
 */
function checkDateserch(){
    var m1 = document.inputform.serdayst.value;
    var m2 = document.inputform.serdayen.value;
    if(m1.length < 10 || m2.length < 10 ){  Util.swalert("검색할 날짜의 시작과 끝 날짜를 입력해 주세요","");return;}
    if (new Date(m1) > new Date(m2)){ Util.swalert("시작날짜가 끝날짜보다 큽니다","");return;}
    document.inputform.showall.value='all';
    document.inputform.submit();
}

/**
 * 소속자 선택
 * @param orderno
 * @param act
 * @param isre
 */
// function reservTo_imoutCheck(orderno, act,isre){
//     const data = {'$p':{}};
//     data.$p = {'from':'일지', 'why':'소속자', 'ordernum':orderno};
//     $j.p.openModal('phone', data);
// }

/**
 * 임의발주
 * @param orderNum
 * @constructor
 */
// function ReservTo_ImuDo(orderNum){
//     var DfiverNo =  parseInt(document.getElementById("selrealtimeondirverno").value);
//     var CarNo =  parseInt(document.getElementById("selrealtimeoncarno").value);
//     var DriverName =  document.getElementById("selrealtimeondirvername").value;
//     var CarPlate =  document.getElementById("selrealtimeoncarplate").value;
//     if( isNaN(DfiverNo)) DfiverNo = 0;
//     if( isNaN(CarNo)) CarNo = 0;
//     if( DfiverNo == 0 ){alert("기사를 선택해 주세요");return;}
//     if( CarNo == 0 ){alert("차량을 선택해 주세요");return;}
//     var TarObj = document.getElementById("driverCarsetf");
//     page_chnage();
//
//     var adr = "/_sky_m_05_ajax_savething.php";
//     var sendData = {"jobtype":"reservordertoimu_changeorder", "ordernum":orderNum, "dirvernum":DfiverNo, "divername":DriverName , "carnum":CarNo, "carplacenum":CarPlate};
//     $.ajax({type:"POST", url:adr , data:sendData , dataType:'json', success:function(data){
//             if(data.result==-100){
//                 alert('수주자의 캐시잔액이 부족합니다.');
//                 return;
//             }
//             document.location.href='?showipicknum=' + orderNum;
//         }});
// }


// 전달사항(발주자·수주자가 서로 보는 글) → HTML. 저장된 <br>(오더 메모의 취소사유 등)만 태그로 남긴다
const memoHtml = (v) => Util.escapeHtml(v).replace(/&lt;\/?br\s*\/?&gt;/gi, '<br>');

// 전달사항 모달 핸들 — 저장 성공 시 memo_set_to() 가 닫는다
let memoModal = null;

/**
 * 실시간 메모톡 (오더전달사항)
 * @param orderNum
 * @param evt
 */
function addmemo(orderNum,evt){
    if( evt.target){
        if( evt.target.id=="bachanotibtn") return;
    }
    window.edit_memoCallNum = orderNum;
    var strsst = "전달사항 입력";
    var hh = "";   // 제목은 모달 헤더가 든다
    var sendData = {"ordernum": orderNum}
    var adr = `/m/ajax/order/${orderNum}/talkmemos`;
    $.ajax({type:"get", url:adr , data:sendData , dataType:'json', success:function(data){
            if(!data) return;
            let oldList = "";
            $.each( data, function( idx, row ) {
                let isDel=false; if( row['mb_no']==MEMBER['num']) isDel=true;
                oldList+=`
                <div class='ordermemoina${row['w']}'> ⊙ ${memoHtml(row['memo'])}
                    <span style='display:flex; justify-content: right; align-items: center; font-size:10px;font-color:var(--diary-text-name)'>
                        ${Util.escapeHtml(row['mem_name'])}
                        ${Util.getSimpleDateTime(row['datetime'])} &nbsp;
                        <input type="button" value="삭제" onclick="deleteMemoea('${row['num']}','${orderNum}',${isDel})" style="padding:0px; margin:0px;width:40px; height:23px;background-color:var(--diary-del-btn-bg);border:none;-webkit-border-radius:5px;border-radius:5px;">
                    </span>    
                    
                </div>
                `;
            });

            hh += `
<div style="width:90%;margin:0px auto;max-height:200px;overflow-y:auto;font-size:15px;padding-top:10px;text-align:left;padding-left:10px;color:var(--diary-ink);margin-bottom:20px" id="memoContents">${oldList}</div>
<div style="text-align:center">
    <textarea id="delivery-message" style="width:90%;height:90px;font-size:15px;" placeHolder="${strsst}"></textarea>
    <div style="width:100%;height:150px;font-size:18px;padding-top:50px;text-align:center;color:var(--diary-ink);display:none" id="memosaveNotice">메모 저장중<br>잠시만 기다려 주세요</div>
    <div style="width:100%;height:10px"></div>
    <input type="button" value="닫기" style="width:60px;height:30px;font-size:15px;color:var(--diary-accent);background-color:var(--diary-surface);border:1px solid var(--diary-accent);-webkit-border-radius:5px;border-radius:5px;" id="savememobtn1">&nbsp;&nbsp;
    <input type="button" value="저장" style="width:70px;height:30px;font-size:15px;background-color:var(--diary-accent);border:none;color:var(--diary-ink-fixed);-webkit-border-radius:5px;border-radius:5px;" id="savememobtn2" onclick="memo_set_to(${orderNum}, event)">
</div>
`;

            memoModal = $j.Ui.Modal.open({ mode: 'center', variant: 'mobile', title: '전달사항', html: hh });
            memoModal.el.on('click', '#savememobtn1', () => memoModal.close());

            // hh += "</div>";
            // var obj = document.getElementById("memoinputmore");
            // obj.innerHTML = hh;
            // document.getElementById("memoinputmoreTop").style.display="block";
            // obj.style.top="50px";
            // obj.style.display='block';
            // document.getElementById("jobmemowrtememo").focus();
            // return;
        }});
}

/**
 * 전달사항 저장하기
 * @param ordernum
 * @param evt
 */
function memo_set_to(ordernum, evt){
    if(evt){
        evt.preventDefault();
        evt.stopPropagation();
    }
    var memoVal = $("#delivery-message").val();
    var nn = parseInt(window.edit_memoCallNum,10);
    if( isNaN(nn)){Util.swalert("메모를 등록할 오더 번호를 받지 못했습니다",""); return; }
    if( memoVal.length < 1 ){ Util.swalert("메모를 한자 이상 입력해 주세요",""); return; }
    var sendData= {"ordernum":window.edit_memoCallNum ,"ordermemo": memoVal};
    $("#delivery-message").hide();
    document.getElementById("memosaveNotice").style.display="block";
    document.getElementById("savememobtn1").type="hidden";
    document.getElementById("savememobtn2").type="hidden";
    $.ajax({
        type : 'POST',url : `/m/ajax/order/${ordernum}/talkmemos`,
        data :sendData ,
        dataType: 'json',
        success : function (data) {
            memoModal.close();
            // document.getElementById('memoinputmore').style.display='none';
            // document.getElementById("memoinputmoreTop").style.display="none";
            showDetailTable(window.lastOpen_Tab_order,window.lastOpen_Tab_tab, window.lastOpen_Tab_act,"", "ForceToTab");
            //document.location.href="/m/diary/list?showipicknum=" + edit_memoCallNum ;
        }
    });
}

/**
 * 실시간 메모톡 삭제
 * @param n 메모PK
 * @param orderNum 오더번호
 * @param isDel 삭제가능 여부
 */
function deleteMemoea(n,orderNum,isDel){
    if(!isDel){
        Util.swalert('타인이 작성한 메모는 삭제할수 없습니다.');
        return;
    }
    Util.swalert(["해당 메모를 삭제 할까요?",'question'],()=>{
        $.ajax({
            type : 'delete',url : `/m/ajax/order/${orderNum}/talkmemos`,
            data : {"delnum": n}, dataType:'json',success : function (data) {
                var ss = window.location.pathname;
                document.location.href= ss + "?showipicknum=" + orderNum ;
            }
        });
    },['확인','아니오']);
}

var m5_chaddrNo = 0;

/**
 * 일지에서 주소변경 누를때 콜백함수
 * @param arr ( lat : 위도 ( 37.56 ), long : 경도 ( 126.97 ), addr : 주소, place : 장소 이름 )
 */
function callbackAddress(arr){
    var adr = `/m/ajax/order/${ORDER['num']}/address`;
    var GPS = arr['lat']+"," + arr['long'];
    var sendData = {
        "jobtype": "m5_addresschangeonly",
        "gpsval": GPS,
        "orderno": ORDER['num'],
        "addressval": arr['addr'],
        "place": arr['place'],
    };
    $.ajax({type:"POST", url:adr , data:sendData , dataType:'json', success:function(data){
        if( arr['place']){
            location.href=`/m/diary?showipicknum=${ORDER['num']}`;
        }else {
            ORDER['site_latlng'] = GPS;
            $(`#ea_addressinside${ORDER['num']}`).text(Util.nvl(arr['addr']));
        }
    }});
}
//////////////////////////////////////////////////
var ThisOrder_HasSign = "";
var ThisOrder_hasDone = 0;

/**
 * 작업 사진 뷰어
 * @param odNum 오더번호
 * @param pNum 순서
 * @param hasSign
 * @param workStatus 오더상태
 */
function showthisPhoto(odNum,pNum,hasSign, workStatus){
    $j.F.Order.Gallery.init(odNum,pNum);
//     photoUPOrderNum = odNum;
//     photo_nowNum = pNum;
//     ThisOrder_HasSign = hasSign;
//     ThisOrder_hasDone = parseInt(workStatus);
//     if( isNaN(ThisOrder_hasDone)) ThisOrder_hasDone = 0;
//     var obj = document.getElementById("photodivlist_" + odNum);
//     var objlist = document.getElementById("onlyphotoDiv" + odNum);
//     var Pinf = document.getElementById("PinfosList_" + odNum);
//     var picons = document.getElementById("photoicons_" + odNum);
//     var PinfosNums = document.getElementById("PinfosNums_" + odNum);
//     var Tar = document.getElementById("photoGallDiv");
//     if( ! obj || ! objlist || ! PinfosNums ){ swalert("사진 정보를 받지 못했습니다","warning"); return; }
//     var nowShowPlist = obj.value.split("|");
//     console.log( nowShowPlist );
//     var PinfosList = Pinf.value.split("|");
//     var PinfosNumLIst = PinfosNums.value.split("|");
//     if( nowShowPlist.length < 2 ){
//         popcloseimg();
//         return;
//     }
//     var ppHTML = document.createElement('div');
//     var inputs = objlist.getElementsByTagName("div");
//     for (var i=0; i < inputs.length ; i++ ){
//         var ediv = document.createElement('div');
//         ediv.setAttribute("style", inputs[i].getAttribute("style"));
//         ediv.innerHTML = inputs[i].innerHTML;
//         ppHTML.appendChild(ediv);
//     }
//
//     var Tar = document.getElementById("photoGallDiv");
//     var chTar = document.getElementById("job_imagshowBigObj");
//     var chTarinfo = document.getElementById("job_imagshowBigObjnNum");
//     var chRsnum = document.getElementById("job_imagshowRsNum");
//
//     var h = $(window).height();
//
//     /*  제스쳐 허용
// 		Tar.addEventListener('touchmove', function(e) {
// 			e.preventDefault();
// 		}, false);
//          */
//     if( Tar.innerHTML.length > 100 && chTar && chTarinfo && hasSign !="reload"){
//         chTar.src=  nowShowPlist[pNum];
//         chTarinfo.value=pNum;
//         chRsnum.value=PinfosNumLIst[pNum];
//         return;
//     }
//     var imgs = "";
//     //imgs +="<div class='photoHolderx1' style='left:50px'>";//imgs +="	<div style='width:100%;overflow-x:auto;display:table-row'>";
//     imgs +="<div style='width:100%;height:15px;'></div>";
//     imgs +="<div style='width:100%;height:60px;'>";
//     imgs +="<table style='width:100%;border:none' border=0>";
//     imgs +="<tr>";
//     imgs +="<td style='text-align:left;border:none;color:#FFFFFF;font-weight:bold'></td>";
//     imgs +="<td style='text-align:right;padding-right:10px;border:none;border:none; position:relative;'>";
//
//     // imgs +="	<a href='javascript:zoomPhoto()'><img src='/img/zoomicon_p.png' style='height:40px'></a>&nbsp;";
//     // if (['2831','9738','17170','2965','2947','2932','3176'].includes(MEMBER['num'])) {
//     imgs +="	<a href='' style='position:absolute; bottom:0; left:0; padding:12px 10px; font-size:14px; font-weight:600; border-radius:8px; background:#ffc72d;'>수정 및 재서명</a>";
//     imgs +="	<a href='javascript:shareFile()' style='position: relative;'  ><img src='/img/share_white2.png' style='height:40px;'><span style='position:absolute; bottom:-24px; left:50%; transform: translate(-50%,0); width: 40px; text-align: center; color:#fff; '>공유</span></a>&nbsp; &nbsp;";
//     // }
//     imgs +="	<a href='javascript:downloadit()' style='position: relative;'><img src='/img/download_white3.png' style='height:40px'><span style='position:absolute; bottom:-24px; left:50%; transform: translate(-50%,0); width: 40px; text-align: center; color:#fff; '>저장</span></a>&nbsp; &nbsp;";
//     imgs +="	<a href='javascript:deleteone()' style='position: relative;'><img src='/img/trash_can_100_white.png' style='height:40px'><span style='position:absolute; bottom:-24px; left:50%; transform: translate(-50%,0); width: 40px; text-align: center; color:#fff; '>삭제</span></a>&nbsp; &nbsp;";
//     imgs +="	<a href='javascript:popcloseimg()' style='position: relative;'><img src='/img/close_white2.png' style='height:40px'></a>&nbsp;";
//     imgs +="</td>";
//     imgs +="</tr><table></div>";
//     imgs +="<div style='width:100%;height:30px;'></div>";
//     imgs +="<div data-status='here' style='border:2px solid #C4C400;width:97%;margin:0px auto;position:relative;left:-4px'>" + ppHTML.innerHTML + "</div>";
//     imgs +="<input type='hidden' id='job_imagshowBigObjnNum' value='" + pNum +"'>";
//     imgs +="<input type='hidden' id='job_imagshowRsNum' value='" + PinfosNumLIst[pNum] +"'>";
//
//     imgs +="<div style='top:10px;left:100px;'>"
//     // imgs +="<div style='display:inline;float:left;padding-left:15px;margin-top:10px'><img src='/img/rotate1.png' onclick='rotateImag("+PinfosNumLIst[pNum] +",-1)'></div>";
//     // imgs +="<div style='display:inline;float:right;padding-right:15px;;margin-top:10px'><img src='/img/rotate2.png'onclick='rotateImag("+PinfosNumLIst[pNum] +",1)'></div>";
//     imgs +="</div><div style='clear:both'></div>";
//     imgs +="</div>";
//     imgs +="<div class='photoHolderx1'><img src='" +nowShowPlist[pNum] + "' style='width:100%' id='job_imagshowBigObj'></div>";
//     Tar.innerHTML = imgs;
//     Tar.style.display="block";
}

/**
 * 오더 사진 목록 로드 → DOM 렌더링
 */
function loadOrderPhotos(ordernum, callback) {
    $.ajax({type:"POST", url:'/m/ajax/diary/order-photos', data:{ordernum: ordernum}, dataType:'json', success:function(res){
        var html = renderOrderPhotos(res);
        var obj = document.getElementById("photoLine_" + ordernum);
        if (obj) obj.innerHTML = html;
        if (callback) callback(res);
    }});
}

/**
 * 사진 목록 JSON → HTML 렌더링
 */
function renderOrderPhotos(res) {
    var ordernum = res.ordernum;
    var orderStatus = res.orderStatus;
    var photos = res.photos || [];
    var fnex = 'notex';

    var P_Docs = '', P_Works = '';
    var PCnt = 0;
    var Plists = '|', Pinfos = '|', Picons = '|', PinfosNums = '|';

    for (var i = 0; i < photos.length; i++) {
        var p = photos[i];
        PCnt++;
        var thumbTag = "<img src='" + p.thumb + "' style='width:50px; height:50px;' onclick=\"showthisPhoto(" + ordernum + "," + p.img_id + ",'" + fnex + "'," + orderStatus + ")\">";

        if (p.phototype == '1') {
            P_Docs += "<div class='work-photo-thumb notification-dot'>" + thumbTag + " </div>";
        } else if (p.phototype == '2') {
            P_Works += "<div class='work-photo-thumb'>" + thumbTag + " </div>";
        } else if (p.phototype == '0' || p.phototype == '3') {
            // 전자작업확인서(최신 0 / 구 3) — 확인서 아이콘으로 표시
            P_Docs += "<div class='work-photo-thumb'><img src='/img/sam_icon_sign.png' style='width:50px; height:50px;' onclick=\"showthisPhoto(" + ordernum + "," + p.img_id + ",'" + fnex + "'," + orderStatus + ")\"></div>";
        } else {
            // 정산서류(통장사본·사업자등록증 등 phototype=99) — 실제 썸네일을 문서 영역에 표시
            P_Docs += "<div class='work-photo-thumb'>" + thumbTag + " </div>";
        }
        Picons += p.thumb + '|';
        Plists += p.url + '|';
        Pinfos += p.phototype + '|';
        PinfosNums += (p.num || '') + '|';
    }
    if (PCnt > 0) Plists = Plists.slice(0, -1);

    var html = '<div style="width:100%;margin:0px auto;text-align:left;font-size:15px;margin-top:0px;" id="photoShow">'
        + '<div style="width:100%;margin:0px auto; padding-top:0px" id="onlyphotoDiv' + ordernum + '">'
        + "<table style='width:100%;border-collapse:collapse;table-layout:fixed;'>"
        + "<colgroup><col style='width:50%'><col style='width:50%'></colgroup>"
        + "<tr style='height:30px'>"
        + "<td style='white-space:nowrap; overflow: hidden;'>"
        + "<div style='width:20px; height:50px; display:inline-block;lborder:1px solid var(--diary-doc-side-border); text-align:center; background-color:var(--diary-doc-side-bg)'>문<br>서</div>"
        + P_Docs + "</td>"
        + "<td style='white-space:nowrap; overflow: hidden;'>"
        + "<div style='width:20px; height:50px; display:inline-block;lborder:1px solid var(--diary-doc-side-border); text-align:center; background-color:var(--diary-doc-side-bg)'>현<br>장</div>"
        + P_Works + "</td>"
        + "</tr></table></div>"
        + '<input type="hidden" id="photoicons_' + ordernum + '" value="' + Picons + '">'
        + '<input type="hidden" id="photodivlist_' + ordernum + '" value="' + Plists + '">'
        + '<input type="hidden" id="PinfosList_' + ordernum + '" value="' + Pinfos + '">'
        + '<input type="hidden" id="PinfosNums_' + ordernum + '" value="' + PinfosNums + '">'
        + '<input type="hidden" id="Pinfoscount_' + ordernum + '" value="' + PCnt + '">'
        + '<input type="hidden" id="thisphotoCntnow' + ordernum + '" value="' + PCnt + '">'
        + '<input type="hidden" id="signOK" value="0">'
        + '<input type="hidden" id="signorder_status" value="">'
        + '</div>';
    return html;
}

function deleteone(){
    if( !confirm('삭제하시겠습니까?')) return;
    var chTarinfo = document.getElementById("job_imagshowRsNum");
    if( ! chTarinfo){
        Util.swalert("삭제할 사진 정보를 받지 못했습니다","warning"); return;
    }
    var delNum = parseInt(chTarinfo.value,10);
    if(isNaN(delNum)){Util.swalert("삭제할 사진 정보가 올바르지 않아 삭제하지 못했습니다","warning"); return;}
    var datas = {"actjob":"deleteonephoto", "deletenum": delNum};
    if(delNum){
        $.ajax({type : 'DELETE',url : `/m/ajax/order/${window.photoUPOrderNum}/photos`,data : datas ,success : function (data) {
                loadOrderPhotos(window.photoUPOrderNum, function(res){
                    if (!res.photos || !res.photos.length) {
                        popcloseimg();
                        return;
                    }
                    showthisPhoto(window.photoUPOrderNum,1,"reload");
                });
            }});
    }else{

    }
}

function popcloseimg(){
    var Tar = document.getElementById("photoGallDiv");
    Tar.innerHTML = "";
    Tar.style.display="none";

    if( Tar) {
        if (Tar.removeEventListener) Tar.removeEventListener('touchmove',null);
    }
    // 일지 사진 목록 갱신
    let ordernum = $j.F.Order.Gallery.ordernum;
    if (ordernum) {
        loadOrderPhotos(ordernum);
    }
}
function shareFile(){
    var Tar = document.getElementById("job_imagshowBigObj");
    if( Tar){
        var imgadr = Tar.src;
        if(!$j.F.App.shareFile(imgadr)){
            alert('앱을 업데이트해주세요');
        }
    }
}
function downloadit(){
    var Tar = document.getElementById("job_imagshowBigObj");
    if( Tar){
        var imgadr = Tar.src;
        // document.location.href=imgadr;
        $j.F.App.downloadImage(imgadr);
    }

}
function get_eaOrder_expancess(ordernum){
    var $tars = $('#expanceLIne_' + ordernum);
    if( !$tars.length ) return;

    $.ajax({
        type : 'GET', url : "/m/ajax/diary/expenses",
        data : { ordernum: ordernum },
        success : function (res) {
            var list = (res && res.list) || [];
            if( !list.length ){ $tars.empty(); return; }

            var cellStyle = "font-size:15px;font-weight:bold;color:var(--diary-ink);text-align:center";
            var rows = list.map(function(r){
                var mainType = String(r.main_type || '').replace('지출항목', '지출');
                var isOnMe = parseInt(r.expance_isonme,10) === 1 ? "<font style='color:var(--diary-sun)'>(자비)</font>" : '';
                var price = parseInt(r.c_price,10).toLocaleString('ko-KR');
                return '<tr>'
                    + '<td style="'+cellStyle+'">' + Util.escapeHtml(r.driver_name) + '</td>'
                    + '<td style="'+cellStyle+'">' + Util.escapeHtml(mainType) + '</td>'
                    + '<td style="'+cellStyle+'">' + Util.escapeHtml(r.sub_type) + isOnMe + '</td>'
                    + '<td style="'+cellStyle+'">' + price + '</td>'
                    + '<td onclick="add_expances(' + parseInt(r.ref_ordernum,10) + ',' + parseInt(r.num,10) + ')">'
                    +     '<font style="font-size:13px;font-weight:bold;color:var(--diary-sat)">수정</font>'
                    + '</td>'
                    + '</tr>';
            }).join('');

            var html = '<table style="width:100%;">'
                + '<colgroup><col style="width:30%"/><col style="width:20%"/><col style="width:20%"/><col style="width:20%"/><col style="width:10%"/></colgroup>'
                + '<tr><td colspan="5" style="height:25px;text-align:center;font-size:16px;font-weight:bolder;color:var(--diary-exp-title-ink);background-color:var(--diary-exp-title-bg)">경비 입.출금 내역</td></tr>'
                + rows
                + '</table>';
            $tars.html(html);
        }
    });
}

/**
 * 작업사진을 크게보기
 * @param orderno
 * @param tar
 * @param signdone
 * @constructor
 */
// function ZoomReady_load(orderno, tar, signdone){
//     if( signdone == "exists" && user_loginNum == 10){
//     }
//     tar.src="/img/loading_cir_80_fit.gif";
//     var D = new Image();
//     D.src="/img/loading_cir_80_fit.gif";
//     D.onload=function(){
//         photoUPOrderNum = orderno;
//         photo_nowNum = 1;
//         zoomPhoto();
//     }
// }

// (제거) phone_call_made — 대상 _sky_m_05_save_dirverInfos.php 가 이 저장소에 존재한 적 없고,
// 호출부($actionafterCall)도 렌더되지 않던 dead 코드였다. 실 통화기록은 record_call_log → /m/ajax/order/call-log.


function resetSearchs(){
    document.location.href="?serch_reset=99";
}

var one_type_callMd = ["", "sky_2000_baljoo","sky_wor_list","cashpointserch","_sky_m_10.php"];

function getDocHeight() {
    // var D = document;
    // wHeight = Math.max(
    //     D.body.scrollHeight, D.documentElement.scrollHeight,
    //     D.body.offsetHeight, D.documentElement.offsetHeight,
    //     D.body.clientHeight, D.documentElement.clientHeight
    // );
    // wWidth = Math.max(
    //     D.body.scrollWidth, D.documentElement.scrollWidth,
    //     D.body.offsetWidth, D.documentElement.offsetWidth,
    //     D.body.clientWidth, D.documentElement.clientWidth
    // );
}




// function setCookie( cookie_title_name , cookie_value, cookie_expire_int_day){
//     var expire = new Date();
//     expire.setDate(expire.getDate() + cookie_expire_int_day);
//     var cookies = cookie_title_name + "=" + cookie_value + ';path=/;expires=' + expire.toGMTString() + ';';
//     document.cookie = cookies;
// }
// function getCookie(cName){
//     if( cName == undefined) return "";
//     var cookieData = document.cookie;
//     var start = cookieData.indexOf(cName);
//     var cValue = '';
//     if(start != -1){
//         start += cName.length;
//         var end = cookieData.indexOf(';', start);
//         if(end == -1)end = cookieData.length;
//         cValue = cookieData.substring(start+1, end);
//     }
//     return cValue;
// }




function work_DocJob(orderno){

}

// (do_order_follow / show_results 는 ProgressBar.js 로 이관 — 폴링·셀갱신 로직 + 셀개수 재렌더 수정 포함.)


/**
 * 본사별 부가정보 칸 이름. 정본은 PHP `OrderQueryService::getOrderExtraColumnName`.
 * order_sosok 은 6·9자리(예: 019004007)라 본사코드를 먼저 뽑아야 한다 —
 * 예전 공통본은 원본을 그대로 switch 해서 늘 빈 문자열을 돌려줬다.
 */
function orderExtraColumnName(sosok) {
    switch (Util.getParentSosokCode(sosok, 1)) {
        case '019': return '수임번호';
        case '021': return '현장명';
        default:    return '';
    }
}

function get_bonsa_col(){
    const orderno=ORDER['num'];
    const preval=ORDER['bonsa_col'];
    const colName = orderExtraColumnName(ORDER['order_sosok']);
    var hh = "<div style='width:100%;display:block;text-align:center;font-size:17px;font-weight:bold; margin-bottom:50px' id='memoboxIn'>";
    hh +=	 "<div style='width:100%;height:40px;line-height:40px;font-size:20px;font-weight:bolder;text-align:center; padding-top:30px; border-bottom:2px solid var(--diary-border)'>"+colName+" 변경</div>";
    hh +=	 "<div style='width:90%;margin:0px auto; line-height:18px;font-size:14px;font-weight:normal;text-align:left; padding-top:30px; margin-bottom:20px; text-align:center'>";
    hh += "	<input type='text' style='width:70%; height:40px; font-size:20px; font-weight:bolder; text-align:center' id='bonsa_colinput' value='"+preval+"'> ";
    hh += "</div>";

    hh +=    "<input type='button' value='취소' style='width:80px;height:50px;font-size:15px; color:var(--diary-accent); background-color:var(--diary-surface); border:1px solid var(--diary-accent);-webkit-border-radius:5px;border-radius:5px; ' onclick=\"memoPopHide()\"' id='savememobtn1'>&nbsp;&nbsp;";
    hh +=    "<input type='button' value='정보 변경' style='width:120px;height:50px;font-size:15px;background-color:var(--diary-accent);border:none; color:var(--diary-ink-fixed);-webkit-border-radius:5px;border-radius:5px;  ' id='changefdinfo' onclick='changeBonsaCol()'>";
    hh += "</div>";
    $('#memoinputmore').html(hh).css('top', '10px');
    memoPopShow();
}

/**
 * 본사별 여분컬럼의 값을 변경하기 ( 삼성은 수임번호, 경원은 현장명 ... )
 */
function changeBonsaCol(){
    var samcd = document.getElementById("bonsa_colinput").value;
    // if( samcd.length  < 15 ){alert("최소 15자 이상 입력해 주세요") ;return;}
    var adr = `/m/ajax/order/${ORDER['num']}/bonsa-col`;
    const orderno= ORDER['num'];
    var sendData = {"bonsa_col":samcd};
    $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
            document.location.href="?showipicknum=" + orderno;
        }});
}

/**
 * 머큐리 보험 정산 소속(화물공제조합 022002·KB손해보험 022003) 일때 보험사 정보
 */
function getMcInsPop(){
    const meta = typeof ORDER['meta'] === 'string' ? JSON.parse(ORDER['meta'] || '{}') : (ORDER['meta'] || {});
    const html = `
<div style="width:100%;box-sizing:border-box;">
    <div style="display:flex;gap:15px;justify-content:center;margin-bottom:10px;">
        <label style="display:flex;align-items:center;gap:4px;"><input type="radio" name="mc_ins_invoice" value="1" ${meta.invoice == '1' ? 'checked' : ''}> 계산서발행</label>
        <label style="display:flex;align-items:center;gap:4px;"><input type="radio" name="mc_ins_invoice" value="0" ${meta.invoice != '1' ? 'checked' : ''}> 미발행</label>
    </div>
    <table style="width:100%;border-collapse:collapse;">
        <tr>
            <td style="padding:6px;font-weight:bold;white-space:nowrap;">보험사명</td>
            <td style="padding:6px;"><input type="text" id="mc_ins_name" value="${Util.escapeHtml(meta.insurance_name)}" style="width:100%;height:36px;border:1px solid var(--diary-border-cc);border-radius:4px;padding:0 8px;"></td>
        </tr>
        <tr>
            <td style="padding:6px;font-weight:bold;white-space:nowrap;">보상팀명</td>
            <td style="padding:6px;"><input type="text" id="mc_ins_team" value="${Util.escapeHtml(meta.team_name)}" style="width:100%;height:36px;border:1px solid var(--diary-border-cc);border-radius:4px;padding:0 8px;"></td>
        </tr>
        <tr>
            <td style="padding:6px;font-weight:bold;white-space:nowrap;">보험사 접수번호</td>
            <td style="padding:6px;"><input type="text" id="mc_ins_code" value="${Util.escapeHtml(meta.receipt_no)}" style="width:100%;height:36px;border:1px solid var(--diary-border-cc);border-radius:4px;padding:0 8px;"></td>
        </tr>
        <tr>
            <td style="padding:6px;font-weight:bold;white-space:nowrap;">담당자명</td>
            <td style="padding:6px;"><input type="text" id="mc_ins_dname" value="${Util.escapeHtml(meta.manager_name)}" style="width:100%;height:36px;border:1px solid var(--diary-border-cc);border-radius:4px;padding:0 8px;"></td>
        </tr>
        <tr>
            <td style="padding:6px;font-weight:bold;white-space:nowrap;">연락처</td>
            <td style="padding:6px;"><input type="tel" id="mc_ins_phone" value="${Util.escapeHtml(Util.phoneNumber(meta.manager_phone || ''))}" style="width:100%;height:36px;border:1px solid var(--diary-border-cc);border-radius:4px;padding:0 8px;"></td>
        </tr>
    </table>
    <div style="text-align:center;margin-top:15px;">
        <button type="button" id="mc_ins_save" style="width:100%;height:42px;font-size:15px;font-weight:bold;color:#fff;background:var(--diary-btn-save-bg);border:none;border-radius:4px;cursor:pointer;">저장</button>
    </div>
</div>`;
    // 제목은 모달 헤더가 든다 (구 본문 첫 줄의 제목 div 제거)
    const m = $j.Ui.Modal.open({ mode: 'center', variant: 'mobile', title: '보험사 정보', html });
    m.el.on('click', '#mc_ins_save', function(){
        const newMeta = JSON.stringify({
            invoice: $('input[name="mc_ins_invoice"]:checked').val(),
            insurance_name: $('#mc_ins_name').val(),
            team_name: $('#mc_ins_team').val(),
            receipt_no: $('#mc_ins_code').val(),
            manager_name: $('#mc_ins_dname').val(),
            manager_phone: $('#mc_ins_phone').val(),
        });
        $.ajax({
            type: 'POST',
            url: `/m/ajax/order/${ORDER['num']}/meta`,
            data: { meta: newMeta },
            success(res){
                if(!res.result) {
                    $j.Common.Util.tsalert('warning', res.message);
                    return;
                }
                ORDER['meta'] = newMeta;
                m.close();
                $j.Common.Util.tsalert('success', '저장되었습니다.');
            }
        });
    });
}


function get_car_parking_pee(orderno, parkingPee){
    var hh = "<div style='width:100%;display:block;text-align:center;font-size:17px;font-weight:bold; margin-bottom:50px' id='memoboxIn'>";
    hh +=	 "<div style='width:100%;height:40px;line-height:40px;font-size:20px;font-weight:bolder;text-align:center; padding-top:30px; border-bottom:2px solid var(--diary-border)'>주차비 변경</div>";
    hh +=	 "<div style='width:90%;margin:0px auto; line-height:18px;font-size:14px;font-weight:normal;text-align:left; padding-top:30px; margin-bottom:20px; text-align:center'>";
    hh += "	<input type='tel' style='width:70%; height:40px; font-size:20px; font-weight:bolder; text-align:center' id='samsungcd_parkingpeein' value='"+ Util.formatNumber(parkingPee)+"'> ";
    hh += "</div>";

    hh +=    "<input type='button' value='취소' style='width:80px;height:50px;font-size:15px; color:var(--diary-accent); background-color:var(--diary-surface); border:1px solid var(--diary-accent);-webkit-border-radius:5px;border-radius:5px; ' onclick=\"memoPopHide()\"' id='savememobtn1'>&nbsp;&nbsp;";
    hh +=    "<input type='button' value='금액 변경' style='width:120px;height:50px;font-size:15px;background-color:var(--diary-accent);border:none; color:var(--diary-ink-fixed);-webkit-border-radius:5px;border-radius:5px;  ' id='changefdinfo' onclick='change_parking_pee(" + orderno + ")'>";
    hh += "</div>";
    $('#memoinputmore').html(hh).css('top', '10px');
    $j.Common.Form.registerNumberHandler('samsungcd_parkingpeein');
    memoPopShow();
}
function change_parking_pee(orderno){
    var ppp = document.getElementById("samsungcd_parkingpeein").value;
    ppp = ppp.replace(/,/gi,"");
    var parkingpee = parseInt(ppp);
    if( isNaN(parkingpee)) parkingpee = 0;
    if( parkingpee == 0 ){if( !confirm("주차요금을 0원으로 설정할까요?")) return;}
    var adr = "/m/ajax/order/parking-fee";
    var sendData = {"ordernum":orderno, "parkingpeeval":parkingpee};
    $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
            document.location.href="?showipicknum=" + orderno;
        }});
}

/**
 * 소속자가 배정확인 버튼을 누를때
 * @param ordernum
 */
function sendNotoTo_ownerorderget(ordernum){
    Util.swalert(["이 오더를 지정자 에게 작업 확인했음을 통지 할까요?",'question'],()=>{
        $('#bachanotibtn').hide();
        $.ajax({type:"POST", url:`/m/ajax/order/${ordernum}/car-confirm` , success:function(data){
                document.location.href="?showipicknum=" + ordernum;
            }});

    },['확인','아니오']);
}

/**
 * 수수료없는 지정발주 오더를 수주자가 확인버튼 눌렀을때
 * @param ordernum
 */
function sendNotoTo_Baljoo_checked(ordernum){
    Util.swalert(["발주자에게 지정 확인했음을 통지 할까요?",'question'],()=>{
        // var adr = "/_push_p_to_p_new.php?listtype=subbuller&ptype=order_current_communicating&ordernum=" + ordernum + "&&notiTypedetail=지정확인&notitype=jijungassigned&notitypesub=tobaljooonly&pagetype=whitenew_sky_m05";
        // document.location.href=adr;
        $.ajax({type:"POST", url:`/m/ajax/order/${ordernum}/car-confirm` , success:function(data){
                document.location.href="?showipicknum=" + ordernum;
            }});

    },['확인','아니오']);
}
function app_priceReservEr(){
    var mg = "금액을 확인해 주세요!\n\n어플 발주시 금액은 정상 금액이여야 합니다.";
    alert(mg);
}

function showMap(gps){
    var adr = "/map/full?gps=" + gps;
    window.open(adr);
}

///////////////////////////////
// function getCookie(cname) {
//     var name = cname + "=";
//     var ca = document.cookie.split(';');
//     for(var i = 0; i <ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0)==' ') {
//             c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//             return c.substring(name.length,c.length);
//         }
//     }
//     return "";
// }

// 수수료 없음으로 변경하기
function setTo_noPee(ordernum){
    Util.swalert(["이 오더를 수수료 없음으로 변경할까요?\n수수료 입금 후 면 수수료가 반환 됩니다.",'question'],()=>{
        $.ajax({
            type:"POST",
            data:{'ordernum': ordernum},
            url: `/m/ajax/order/${ordernum}/nofee`,
            dataType: 'json',
            success: function(data){
                if( data.result ){
                    document.location.href='/m/diary?showipicknum='+ordernum;
                }else{
                    alert(data.message);
                }
            }
        });
    },['확인','아니오']);
}

function AserverNot(){
}

/**
 * 일지에서 차량을 변경한다.
 * @param no
 */
// 작업 장비번호 등록 — 카드의 차량번호 클릭(OrderDetailViewService 인라인 onclick).
// jquery-modal → BottomSheet. 중앙 고정 height:auto 모달이라 등록 장비가 많거나 글자를 키우면
// 목록이 뷰포트를 넘어 잘리고 닫기 수단까지 사라졌다.
function changePlateNum(no){
    $.ajax({
        type: "get",
        url: "/m/ajax/cars/list",
        success: function(res) {
            const list = res.c; // 차량목록
            if(!list) return;

            let items = '';
            $.each(list, function(carnum, carplate){
                items += `<button type="button" class="plate__item" data-carnum="${Util.escapeHtml(carnum)}" data-plate="${Util.escapeHtml(carplate)}">`
                       + `${carplate ? Util.escapeHtml(carplate) : '차량번호없음'}</button>`;
            });

            const html = `
<div class="plate">
    <input type="text" id="minputcarplate" class="plate__input" value="" placeholder="실제 현장에서 작업한 차량번호 입력">
    <input type="hidden" id="minputcarplateno" value="0">
    <div class="dsheet__foot">
        <button type="button" class="dsheet__btn" data-act="cancel">취소</button>
        <button type="button" class="dsheet__btn dsheet__btn--ok" data-act="save">저장</button>
    </div>
    <div class="plate__guide">아래는 회원님에게 등록된 장비입니다.<br>직접 입력하거나 목록에서 고르세요.</div>
    <div class="plate__list" id="mycarListMainCont">${items}</div>
</div>`;

            $j.Ui.BS.open({
                fixedHeight: true,
                target: {
                    init() {
                        const $el = $('#' + this.id).html(html);
                        $el.on('click', '.plate__item', function(){
                            $('#minputcarplate').val($(this).data('plate'));
                            $('#minputcarplateno').val($(this).data('carnum'));
                        });
                        $el.on('click', '[data-act="cancel"]', () => $j.Ui.BS.close());
                        $el.on('click', '[data-act="save"]',   () => saveCarPlateFront());
                    },
                    destroy() { $('#' + this.id).off(); },
                },
            });
            $j.Ui.BS.setTitle('작업 장비번호 등록');
        }
    });
}

function saveCarPlateFront(n){
    if( n == -1 ){ $j.Ui.BS.close(); return; }

    var carplate = document.getElementById("minputcarplate").value || "";
    var carno = parseInt(document.getElementById("minputcarplateno").value, 10);
    if( isNaN(carno) ) carno = 0;
    if( carplate.length < 3 ){ Util.swalert("장비 번호를 최소 3자이상 입력해 주세요"); return; }

    $.ajax({type:"POST", url:"/m/ajax/order/carplate",
        data:{"ordernum":window.handle_orderNum, "carnum":carno, "carplatenum":carplate},
        success:function(){
            document.location.href = "?showipicknum=" + window.handle_orderNum;
        }});
}

function FilterSelectSetdo(n){
    window.dir_Showmode = n;
    var wYear = parseInt(document.getElementById("calender_yearval").value);
    var wMonth = parseInt(document.getElementById("calender_monthval").value);
    var adr = "?dshowtype=" + window.dir_Showmode + "&toYear=" + wYear + "&toMonth=" + wMonth;
    console.log("Godir : "+ adr );
    document.location.href=adr;
}

function FilterSelect(){
    console.log("dir_Showmode:" + window.dir_Showmode );

    if( window.dir_Showmode == 1 ){
        window.dir_Showmode = 2;
    }else if( window.dir_Showmode == 2 ) {
        window.dir_Showmode = 3;
    }else if( window.dir_Showmode == 3 ) {
        window.dir_Showmode = 1;
    }else{
        window.dir_Showmode = 1;
    }
    var wYear = parseInt(document.getElementById("calender_yearval").value);
    var wMonth = parseInt(document.getElementById("calender_monthval").value);
    var adr = "?dshowtype=" + window.dir_Showmode + "&toYear=" + wYear + "&toMonth=" + wMonth;
    console.log("Godir : "+ adr );
    document.location.href=adr;
}

function address_result_Show(data){
    var cc = data.length;

    //return;
    if( cc == 0 ){
        if( last_r_Cnt > 0 ){
            return;
        }
    }
    var obj = document.getElementById("searchRstMoreTop");
    document.getElementById("searchRstDaum").innerHTML = data;
    var hh = $(window).height();
    obj.style.maxHeight  = parseInt( hh - 50) + "px";
    obj.style.display="block";
}
function address_result_ShowDB(data){
    document.getElementById("searchRstLocal").innerHTML = data;
    var obj = document.getElementById("searchRstMoreTop");
    var hh = $(window).height();
    obj.style.maxHeight  = parseInt( hh - 50) + "px";
    obj.style.display="block"
    document.getElementById("searchRstLocal").innerHTML = data;
    if( document.getElementById("nogibun")){
        var nogibun = document.getElementById("nogibun").innerHTML;
        if( nogibun.length > 3 ){
            fill_gibun_info(nogibun);
        }
    }
}

function getNum(sTest){
    var nTmp=sTest.charCodeAt(0) - 0xAC00;
    var jong=nTmp % 28; // 종성
    var jung=( (nTmp-jong)/28 ) % 21; // 중성
    var cho=( ( (nTmp-jong)/28 ) - jung ) / 21; // 종성
    var serNo = rCho.indexOf(rCho[cho]);
    if( serNo < 0) {
        if(rCho.indexOf(sTest) >= 0 ){
            serNo = rCho.indexOf(sTest) ;
        }
    }
    var retNum = "000" + serNo;
    if( serNo > 9 ) retNum = "00" + serNo;
    if( serNo < 0) retNum = "" + serNo;
    return retNum;
}

////////////////////////////////////////////////////////////////////////////////////
function diary_RegnewTypeSelBtns(){

    var dast = "width:97%; margin:0px auto; text-align:left; font-size:13px;padding-left:3px;white-space:nowrap; margin:10px 0px ";
    var GabDiv = "<div style='width:100%; clear:both; height:10px; border-top:1px solid var(--diary-border-dim)'></div>";
    var EndDiv = "<div style='width:100%; clear:both; height:10px; border-top:0px solid var(--diary-border-dim)'></div>";
    // 구 add_btn_black.png(검정 + 아이콘) 대체. 이미지라 다크에서 안 보였고, img+div 를
    // top:-3px/-6px 로 각각 밀어 올려 글자가 버튼 위쪽에 치우쳐 있었다.
    // 스타일은 pages/_diary.scss 의 .dia-regbtn (+ 는 ::before, 글자색을 따라간다)
    var btnImg = "등록";
    var btnImK = "발주";
    var ret = "";
    ret += "<div style='width:95%; margin:0px auto'>";
    ret += "	<div style='width:100%; text-align:center; font-size:15px; font-weight:bolder'>일지관리 하기</div>";
    ret +=  EndDiv;
    ret += "	<div style='" + dast + "'>";
    ret += "		<div style='width:-moz-calc(100% - 100px);width:-webkit-calc(100% - 100px);width:calc(100% - 100px);display:inline-block'>";
    //ret += "			예약, 지난오더 일지 등록하기";
    ret += "			작업 한(할) 오더 등록하기";
    ret += "		</div>";
    ret += "		<div class='dia-regbtn' onclick='add_jobIn()'>" + btnImg + "</div>";
    ret += "	</div><div style='width:!00%; clear:both; height:10px'></div>";
    ret +=  GabDiv;

    ret += "	<div style='" + dast + "'>";
    ret += "		<div style='width:-moz-calc(100% - 100px);width:-webkit-calc(100% - 100px);width:calc(100% - 100px);display:inline-block'>";
    ret += "			실시간 회원에게 배차히기<br><br>";
    ret += "		</div>";
    ret += "		<div class='dia-regbtn' onclick='add_jobIn(this)'>" + btnImK + "</div>";
    ret += "	</div>";
    //ret +=  GabDiv;
    //ret += "	<div style='width:95%; text-align:left;'>";
    //ret += "<a href='http://sub.jbbuller.kr/_sky_m_05_0A_reghtml.php'></a>";
    //ret += "한번 등록으로 알람기능 / 수첩기능 / 메모 / 수입,지출 / 차계부 / 거래명세서 / 세금계산서 / 직원 급여관리 등 장부 정리를 한번에<br><br>";
    //ret += "타 장비기사가 작업한 오더를 등록시 장비부러! 회원인 경우 등록한 오더가 '일지'에서 연동됩니다.<br><br>";
    ret += "	</div>";
    ret +=  EndDiv;
    ret += "</div>";
    return ret ;
}
var worktypeSet = 0;

// (중복 loadScript 선언 제거 — strict 모듈 중복함수 불가, 동일본문이 아래 3700+ 에 재선언됨)

// 구 device_backButtonCall() (앱이 하드웨어 백버튼에서 직접 호출) 은 2026-08 제거 — 앱 발화가 이미 0건이었다.

var billSetNum = 0 , billSetTar = null, billsetDiv = null, moreTaxScripLoad = 0;;
// 계산서/거래처입금 — 카드의 라디오 토글(setBillStatsDo)과 입력 시트(F/Diary/TaxBill) 진입점.
// 인라인 onclick(OrderDetailViewService·TaxBill 저장 콜백)이 bare 로 부르므로 window 에 남는다.
function setBillStats(tar,tarnum, tarDiv, carPrice){
    if( tar == -1 ){
        if( $('.bottomsheet-popup').hasClass('is-open') ) $j.Ui.BS.close();
        return;
    }
    billSetNum = tarnum; billSetTar = tar; window.billsetDiv = tarDiv;

    if( tar == "bal_bill_issued" || tar == "soo_bill_issued" ){
        $j.F.Diary.TaxBill.open(tar, tarnum, tarDiv, carPrice);
    }else{
        setBillStatsDo();
    }
}

function setBillStatsDo(){
    var adr = "/m/ajax/order/bill-status";
    var sets = parseInt(window.billsetDiv.getAttribute("mydataval"));
    console.log( sets );

    if( isNaN(sets)) sets = 0;
    sets == 0 ? sets = 1: sets = 0;
    var sendData = {"tarfield":billSetTar, "setval":sets , "tarnum":billSetNum};
    console.log( billSetTar + " => " + sets );
    console.log( sendData );
    $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
            // 체크 표시는 CSS(.dia-rdo) — 구 radio_billstatus_*.png 대체. 미체크는 빈 링이다.
            var ret = "<span class='dia-rdo" + (sets == 1 ? " is-on" : "") + "' style='position:relative;vertical-align:top;top:5px'></span>";
            ret += "<div style='display:inline-block;position:relative;vertical-align:top;line-height:30px;top:5px'>" ;
            if( billSetTar == "soo_bill_issued"){
                sets == 1 ?  ret += "계산서 <font style='color:var(--diary-sat)'>발행</font>" : ret +="계산서 <font style='color:var(--diary-sun)'>미발행</font>";
            }else if( billSetTar == "bal_bill_issued"){
                sets == 1 ?  ret += "거래처 <font style='color:var(--diary-sat)'>발행</font>" : ret +="거래처 <font style='color:var(--diary-sun)'>미발행</font>";
            }else{
                sets == 1 ?  ret += "계산서 <font style='color:var(--diary-sat)'>받음</font>" : ret += "계산서 <font style='color:var(--diary-sun)'>안받음</font>";
            }
            ret += "</div> &nbsp;"
            window.billsetDiv.innerHTML =  ret ;
            window.billsetDiv.setAttribute("mydataval" , sets);
            console.log(data);
        }});
}


function loadScript(src) {
    return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}
function reg_TaxmoreScript(){
    // 세금계산서 로직은 main.js(F/Diary/TaxBill)로 상시 로드됨 → 동적 로드 불필요.
    // (구 /js/m-diary-1.js 이관, diary-js-migration.md §3)
    moreTaxScripLoad=1;
}
// 구 work_Diary_Dayshow(orderNo) (푸시 수신 후 앱이 일지 일자화면으로 전환시키던 진입점) 은 2026-08 제거.
// 대체가 필요하면 딥링크(callbackDeeplink code '005') 로 처리한다.
function showDoc(evt, onum, ty){
    console.log( onum + " / " + ty );
    evt.preventDefault();
    evt.stopPropagation();
    var obja = document.getElementById("soos_docs_" + onum);
    var objb = document.getElementById("bals_docs_" + onum);
    var objc = document.getElementById("doccalbtna_"+ onum);
    var objd = document.getElementById("doccalbtnb_"+ onum);
    objc.style.backgroundColor="var(--diary-doc-on-bg)";
    objd.style.backgroundColor="var(--diary-doc-on-bg)";
    objc.style.color="var(--diary-ink)";
    objd.style.color="var(--diary-ink)";

    if( ty == 1 ){
        obja.style.display="none";
        objb.style.display="block";
        objc.style.backgroundColor="var(--diary-doc-off-bg)";
        objc.style.color="var(--diary-text-sub)";
    }else{
        obja.style.display="block";
        objb.style.display="none";
        objd.style.backgroundColor="var(--diary-doc-off-bg)";
        objd.style.color="var(--diary-text-sub)";
    }
    //soos_docs_  bals_docs_  $a1bg = "#B4B4BA"; $a1cc = "#808080";
}

function sendMydocTo(tar, doctype){
    // alert(tar);
    // alert(doctype);
    var obj = document.getElementById("selectSendDocBox");
    if( obj ) document.body.removeChild(obj);
    if(tar == -1) return;
    var ordernum = Util.int(tar.getAttribute("ordernum"));
    if( doctype == "bal_defdoc"){
        // console.log("발주자 기본문서 보내기");
        Util.swalert(["이 오더 수주자에게 내 기본문서를 공개할까요?",'question'],()=>{
            $.ajax({type:"POST", url:"/m/ajax/doc-share/level", data:{ordernum:ordernum, side:"bal", level:1}, success:function(data){
                    // 서버가 오더 당사자인지 본다 — 거절이면 화면을 새로 고치지 않고 이유를 보여 준다
                    if( data && data.result === false ){ Util.swalert(data.error || "공개할 수 없습니다.",'error'); return; }
                    $j.Ui.Toast.show("서류를 공개했습니다.", { type:'success' });
                    set_userDocShare(ordernum);
                }});
        },['네','아니오']);

        return;
    }

    var mymemno = Util.int(tar.getAttribute("mymemno"));
    var othernumno = Util.int(tar.getAttribute("othernumno"));
    var soo_cntdef = Util.int(tar.getAttribute("soo_cntdef"));
    var soo_cntcar = Util.int(tar.getAttribute("soo_cntcar"));
    var soo_cntman = Util.int(tar.getAttribute("soo_cntman"));

    var notilist_autocall = tar.getAttribute("notilist_autocall");
    var notilist_autosetnum = Util.int(tar.getAttribute("notilist_autosetnum"));

    $j.F.Diary.DocShareSheet.open({
        sendType:"sendto", ordernum:ordernum, othernum:othernumno,
        defCnt:soo_cntdef, carCnt:soo_cntcar, manCnt:soo_cntman,
        autoCall:notilist_autocall, autoSetNum:notilist_autosetnum,
    });
}

/**
 * 고른 범위를 서버에 반영한다 — 구 sendDocSetCheck + chDocSels 대체.
 *
 * 구 코드는 체크박스 3개를 읽어 **켜진 개수**로 범위를 셌다. 누적을 체크박스로 그린 탓에
 * '장비문서'만 켜면 기본문서가 조용히 함께 켜지는 보정(chDocSels)이 따로 필요했고,
 * 그래서 고른 것과 나가는 것이 어긋났다. 이제 시트가 단계 하나(1~3)만 넘긴다.
 *
 * @param {object} o  시트에 넘겼던 값 (ordernum · othernum · sendType)
 * @param {number} lv 1 기본 / 2 기본+장비 / 3 기본+장비+기사
 */
function sendDocShareLevel(o, lv){
    var ordernum = Util.int(o.ordernum);

    if( o.sendType == "request" ){
        if( Util.int(o.othernum) < 1 ){ Util.swalert("요청할 대상이 없습니다.",'error'); return; }
        $.ajax({type:"POST", url:"/m/ajax/doc-share/request",
            data:{ordernum:ordernum, sendto:Util.int(o.othernum), requesttype:"iwantsools_doc", requestrange:lv},
            success:function(data){
                if( data && data.result === false ){ Util.swalert(data.error || "요청할 수 없습니다.",'error'); return; }
                $j.Ui.Toast.show("서류 요청을 보냈습니다.", { type:'success' });
                set_userDocShare(ordernum);
            }});
        return;
    }

    $.ajax({type:"POST", url:"/m/ajax/doc-share/level", data:{ordernum:ordernum, side:"soo", level:lv},
        success:function(data){
            if( data && data.result === false ){ Util.swalert(data.error || "공개할 수 없습니다.",'error'); return; }
            $j.Ui.Toast.show("서류 공개 범위를 저장했습니다.", { type:'success' });
            set_userDocShare(ordernum);
        }});
}
function sendRequestTo( tar , doctype, acttype){
    askIfRejected(tar, function(){ _sendRequestTo(tar, doctype, acttype); });
}

function _sendRequestTo( tar , doctype, acttype){
    if( acttype == 2 ){ // 수주자에게 기본서류 및 기타 요청하기
        var obj = document.getElementById("selectSendDocBox");
        if( obj ) document.body.removeChild(obj);
        if(tar == -1) return;
        var ordernum = Util.int(tar.getAttribute("ordernum"));
        var mymemno = Util.int(tar.getAttribute("mymemno"));
        var othernumno = Util.int(tar.getAttribute("othernumno"));
        var soo_cntdef = Util.int(tar.getAttribute("soo_cntdef"));
        var soo_cntcar = Util.int(tar.getAttribute("soo_cntcar"));
        var soo_cntman = Util.int(tar.getAttribute("soo_cntman"));
        $j.F.Diary.DocShareSheet.open({
            sendType:"request", ordernum:ordernum, othernum:othernumno,
            defCnt:soo_cntdef, carCnt:soo_cntcar, manCnt:soo_cntman,
        });

    }else if( acttype == 1 ){ // 발주자 에게 기본서류 및 기타 요청하기
        var ordernum = Util.int(tar.getAttribute("ordernum"));
        var mymemno = Util.int(tar.getAttribute("mymemno"));
        console.log("발주자 서류 요청하기 = " + othernumno);
        var othernum =Util.int(tar.getAttribute("othernumno"));
        if( othernum < 1 ){alert("요청할 대상이 없습니다."); return;}
        var adr = "/m/ajax/doc-share/request";
        var sendData = {"ordernum":ordernum, "sendto":othernum, "requesttype":"iwantbals_doc", "requestrange":1 };
        console.log( sendData );
        $.ajax({type:"POST", url:adr , data:sendData , success:function(data){
                if( data && data.result === false ){ Util.swalert(data.error || "요청할 수 없습니다.",'error'); return; }
                $j.Ui.Toast.show("서류 요청을 보냈습니다.", { type:'success' });
                set_userDocShare(ordernum);
            }});
    }
}

/**
 * 이미지 리스트 뷰어
 * @param tar
 * @param file_id
 */
function imageShowList(tar, file_id){
    var obj = document.getElementById(tar);
    if (!obj) { alert("에러 : 대상이 없습니다."); return; }

    var items = [];
    var fullUrls = "";
    var idx = 0;
    $('img[id^="docImg_"]').each(function(i){
        var src = $(this).attr('src');
        var id = $(this).attr('id').replace('docImg_','');
        var originalUrl = Util.toOriginalUrl(src);
        items.push({ url: originalUrl });
        fullUrls += originalUrl + ',';
        if (file_id == id) idx = i;
    });

    if (items.length) {
        $j.Ui.ZoomPhoto.open(null, { items: items, index: idx, downloadable: true, });
    }
}

/**
 * 현장위치 변경을 위한 지도를 띄운다.
 */
function modalMap(el){
    let adr = $(el).parent("td").find("span").text();
    $j.F.KakaoMap.open(ORDER["site_latlng"],'1',adr);
}

/**
 * 안전실천서약서를 서명하라고 소속자에게 알림톡으로 전송한다.
 * @param mb_no
 */
function requestRemoteSafetySign(mb_no){
    $.ajax({
            url: `/m/ajax/sign/safety/request`,
            type: 'POST',
            data: {
                mb_no
            },
            success: function (r) {
                if(!r.result){
                    Util.swalert(r.message);
                    return;
                }
                Util.swalert('요청이 완료되었습니다.');
            }
        }
    );
}